// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/chart.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/artifacts/v1/chart.proto.
 */
export const file_chalk_artifacts_v1_chart: GenFile = /*@__PURE__*/
  fileDesc("Ch5jaGFsay9hcnRpZmFjdHMvdjEvY2hhcnQucHJvdG8SEmNoYWxrLmFydGlmYWN0cy52MSKtAgoMQWxlcnRUcmlnZ2VyEgwKBG5hbWUYASABKAkSNwoIc2V2ZXJpdHkYAiABKA4yJS5jaGFsay5hcnRpZmFjdHMudjEuQWxlcnRTZXZlcml0eUtpbmQSPQoSdGhyZXNob2xkX3Bvc2l0aW9uGAMgASgOMiEuY2hhbGsuYXJ0aWZhY3RzLnYxLlRocmVzaG9sZEtpbmQSFwoPdGhyZXNob2xkX3ZhbHVlGAQgASgCEhgKC3Nlcmllc19uYW1lGAUgASgJSACIAQESGQoMY2hhbm5lbF9uYW1lGAYgASgJSAGIAQESGAoLZGVzY3JpcHRpb24YByABKAlIAogBAUIOCgxfc2VyaWVzX25hbWVCDwoNX2NoYW5uZWxfbmFtZUIOCgxfZGVzY3JpcHRpb24iYwoVRGF0YXNldEZlYXR1cmVPcGVyYW5kEg8KB2RhdGFzZXQYASABKAkSDwoHZmVhdHVyZRgCIAEoCRIYCgtyZXZpc2lvbl9pZBgDIAEoCUgAiAEBQg4KDF9yZXZpc2lvbl9pZCKMAgoNTWV0cmljRm9ybXVsYRIzCgRraW5kGAEgASgOMiUuY2hhbGsuYXJ0aWZhY3RzLnYxLk1ldHJpY0Zvcm11bGFLaW5kEiMKFnNpbmdsZV9zZXJpZXNfb3BlcmFuZHMYAiABKANIAIgBARIdChVtdWx0aV9zZXJpZXNfb3BlcmFuZHMYAyADKAMSSwoYZGF0YXNldF9mZWF0dXJlX29wZXJhbmRzGAQgASgLMikuY2hhbGsuYXJ0aWZhY3RzLnYxLkRhdGFzZXRGZWF0dXJlT3BlcmFuZBIRCgRuYW1lGAUgASgJSAGIAQFCGQoXX3NpbmdsZV9zZXJpZXNfb3BlcmFuZHNCBwoFX25hbWUigwEKDE1ldHJpY0ZpbHRlchIsCgRraW5kGAEgASgOMh4uY2hhbGsuYXJ0aWZhY3RzLnYxLkZpbHRlcktpbmQSNgoKY29tcGFyYXRvchgCIAEoDjIiLmNoYWxrLmFydGlmYWN0cy52MS5Db21wYXJhdG9yS2luZBINCgV2YWx1ZRgDIAMoCSJtChVSYXdNZXRyaWNMYWJlbE1hdGNoZXISDQoFbGFiZWwYASABKAkSNgoKY29tcGFyYXRvchgCIAEoDjIiLmNoYWxrLmFydGlmYWN0cy52MS5Db21wYXJhdG9yS2luZBINCgV2YWx1ZRgDIAMoCSLrAQoPUmF3TWV0cmljU2VyaWVzEhMKC21ldHJpY19uYW1lGAEgASgJEjsKCG1hdGNoZXJzGAIgAygLMikuY2hhbGsuYXJ0aWZhY3RzLnYxLlJhd01ldHJpY0xhYmVsTWF0Y2hlchIQCghncm91cF9ieRgDIAMoCRIWCgltZXRyaWNzcWwYBCABKAlIAIgBARI/Cgp2YWx1ZV9raW5kGAUgASgOMiYuY2hhbGsuYXJ0aWZhY3RzLnYxLlJhd01ldHJpY1ZhbHVlS2luZEgBiAEBQgwKCl9tZXRyaWNzcWxCDQoLX3ZhbHVlX2tpbmQiiQMKEk1ldHJpY0NvbmZpZ1NlcmllcxIuCgZtZXRyaWMYASABKA4yHi5jaGFsay5hcnRpZmFjdHMudjEuTWV0cmljS2luZBIxCgdmaWx0ZXJzGAIgAygLMiAuY2hhbGsuYXJ0aWZhY3RzLnYxLk1ldHJpY0ZpbHRlchIRCgRuYW1lGAMgASgJSACIAQESPwoPd2luZG93X2Z1bmN0aW9uGAQgASgOMiYuY2hhbGsuYXJ0aWZhY3RzLnYxLldpbmRvd0Z1bmN0aW9uS2luZBIxCghncm91cF9ieRgFIAMoDjIfLmNoYWxrLmFydGlmYWN0cy52MS5Hcm91cEJ5S2luZBIyCgp0aW1lX3NoaWZ0GAYgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uSAGIAQESNQoDcmF3GAcgASgLMiMuY2hhbGsuYXJ0aWZhY3RzLnYxLlJhd01ldHJpY1Nlcmllc0gCiAEBQgcKBV9uYW1lQg0KC190aW1lX3NoaWZ0QgYKBF9yYXciIAoeVGltZVNlcmllc1Zpc3VhbGl6YXRpb25PcHRpb25zIh8KHVN0YXRpc3RpY1Zpc3VhbGl6YXRpb25PcHRpb25zIoMECgxNZXRyaWNDb25maWcSDAoEbmFtZRgBIAEoCRIVCg13aW5kb3dfcGVyaW9kGAIgASgJEjYKBnNlcmllcxgDIAMoCzImLmNoYWxrLmFydGlmYWN0cy52MS5NZXRyaWNDb25maWdTZXJpZXMSMwoIZm9ybXVsYXMYBCADKAsyIS5jaGFsay5hcnRpZmFjdHMudjEuTWV0cmljRm9ybXVsYRIUCgxtcWxfZm9ybXVsYXMYCyADKAkSMQoHdHJpZ2dlchgFIAEoCzIgLmNoYWxrLmFydGlmYWN0cy52MS5BbGVydFRyaWdnZXISFwoPZ3JhcGhfZ2VuZXJhdGVkGAYgASgIEgoKAmlkGAcgASgJEiIKFWRpc3BsYXlfd2luZG93X3BlcmlvZBgIIAEoCUgBiAEBElEKE3RpbWVfc2VyaWVzX29wdGlvbnMYCSABKAsyMi5jaGFsay5hcnRpZmFjdHMudjEuVGltZVNlcmllc1Zpc3VhbGl6YXRpb25PcHRpb25zSAASSQoMc3RhdF9vcHRpb25zGAogASgLMjEuY2hhbGsuYXJ0aWZhY3RzLnYxLlN0YXRpc3RpY1Zpc3VhbGl6YXRpb25PcHRpb25zSABCFwoVdmlzdWFsaXphdGlvbl9vcHRpb25zQhgKFl9kaXNwbGF5X3dpbmRvd19wZXJpb2Qi0AEKBUNoYXJ0EgoKAmlkGAEgASgJEjAKBmNvbmZpZxgCIAEoCzIgLmNoYWxrLmFydGlmYWN0cy52MS5NZXRyaWNDb25maWcSNgoLZW50aXR5X2tpbmQYAyABKA4yIS5jaGFsay5hcnRpZmFjdHMudjEuQ2hhcnRMaW5rS2luZBIWCgllbnRpdHlfaWQYBCABKAlIAIgBARIXCg9ncmFwaF9nZW5lcmF0ZWQYBSABKAgSEgoKaXNfdmlydHVhbBgGIAEoCEIMCgpfZW50aXR5X2lkKrY4CgpNZXRyaWNLaW5kEhsKF01FVFJJQ19LSU5EX1VOU1BFQ0lGSUVEEAASJQohTUVUUklDX0tJTkRfRkVBVFVSRV9SRVFVRVNUX0NPVU5UEAESHwobTUVUUklDX0tJTkRfRkVBVFVSRV9MQVRFTkNZEAISIQodTUVUUklDX0tJTkRfRkVBVFVSRV9TVEFMRU5FU1MQAxIdChlNRVRSSUNfS0lORF9GRUFUVVJFX1ZBTFVFEAQSHQoZTUVUUklDX0tJTkRfRkVBVFVSRV9XUklURRAFEiIKHk1FVFJJQ19LSU5EX0ZFQVRVUkVfTlVMTF9SQVRJTxAGEiYKIk1FVFJJQ19LSU5EX1JFU09MVkVSX1JFUVVFU1RfQ09VTlQQBxIgChxNRVRSSUNfS0lORF9SRVNPTFZFUl9MQVRFTkNZEAgSJgoiTUVUUklDX0tJTkRfUkVTT0xWRVJfU1VDQ0VTU19SQVRJTxAJEhsKF01FVFJJQ19LSU5EX1FVRVJZX0NPVU5UEAoSHQoZTUVUUklDX0tJTkRfUVVFUllfTEFURU5DWRALEiMKH01FVFJJQ19LSU5EX1FVRVJZX1NVQ0NFU1NfUkFUSU8QDBIhCh1NRVRSSUNfS0lORF9CSUxMSU5HX0lORkVSRU5DRRANEhwKGE1FVFJJQ19LSU5EX0JJTExJTkdfQ1JPThAOEiEKHU1FVFJJQ19LSU5EX0JJTExJTkdfTUlHUkFUSU9OEA8SGgoWTUVUUklDX0tJTkRfQ1JPTl9DT1VOVBAQEhwKGE1FVFJJQ19LSU5EX0NST05fTEFURU5DWRAREikKJU1FVFJJQ19LSU5EX1NUUkVBTV9NRVNTQUdFU19QUk9DRVNTRUQQEhImCiJNRVRSSUNfS0lORF9TVFJFQU1fTUVTU0FHRV9MQVRFTkNZEBMSKAokTUVUUklDX0tJTkRfU1RSRUFNX1dJTkRPV1NfUFJPQ0VTU0VEEBQSJQohTUVUUklDX0tJTkRfU1RSRUFNX1dJTkRPV19MQVRFTkNZEBUSJgoiTUVUUklDX0tJTkRfT05MSU5FX1NUT1JFX0tFWV9DT1VOVBAWEi4KKk1FVFJJQ19LSU5EX09OTElORV9TVE9SRV9FWFBJUkVEX0tFWV9DT1VOVBAXEjAKLE1FVFJJQ19LSU5EX09OTElORV9TVE9SRV9SRVFVRVNUU19QRVJfU0VDT05EEBgSJwojTUVUUklDX0tJTkRfQ1BVX1VUSUxJWkFUSU9OX1BFUkNFTlQQGRIdChlNRVRSSUNfS0lORF9SRVBMSUNBX0NPVU5UEBoSKAokTUVUUklDX0tJTkRfT05MSU5FX1NUT1JFX1VTRURfTUVNT1JZEBsSKQolTUVUUklDX0tJTkRfT05MSU5FX1NUT1JFX1RPVEFMX01FTU9SWRAcEiIKHk1FVFJJQ19LSU5EX01FTU9SWV9VU0FHRV9CWVRFUxAdEiwKKE1FVFJJQ19LSU5EX1RPVEFMX01FTU9SWV9BVkFJTEFCTEVfQllURVMQHhIiCh5NRVRSSUNfS0lORF9ORVRXT1JLX1JFQURfQllURVMQHxIjCh9NRVRSSUNfS0lORF9ORVRXT1JLX1dSSVRFX0JZVEVTECASHwobTUVUUklDX0tJTkRfRElTS19SRUFEX0JZVEVTECESIAocTUVUUklDX0tJTkRfRElTS19XUklURV9CWVRFUxAiEhoKFk1FVFJJQ19LSU5EX1NUUkVBTV9MQUcQIxIVChFNRVRSSUNfS0lORF9VU0FHRRAkEiYKIk1FVFJJQ19LSU5EX0ZFQVRVUkVfQ09NUFVURURfQ09VTlQQJRInCiNNRVRSSUNfS0lORF9GRUFUVVJFX0xPT0tFRF9VUF9DT1VOVBAmEioKJk1FVFJJQ19LSU5EX0ZFQVRVUkVfSU5URVJNRURJQVRFX0NPVU5UECcSKwonTUVUUklDX0tJTkRfRkVBVFVSRV9DT01QVVRFRF9OVUxMX1JBVElPECgSLAooTUVUUklDX0tJTkRfRkVBVFVSRV9MT09LRURfVVBfTlVMTF9SQVRJTxApEi8KK01FVFJJQ19LSU5EX0ZFQVRVUkVfSU5URVJNRURJQVRFX05VTExfUkFUSU8QKhIjCh9NRVRSSUNfS0lORF9TVFJFQU1fSU5HRVNUX0RFTEFZECsSJgoiTUVUUklDX0tJTkRfQ09OVEFJTkVSX01FTU9SWV9CWVRFUxAsEiEKHU1FVFJJQ19LSU5EX0hPU1RfTUVNT1JZX0JZVEVTEC0SKQolTUVUUklDX0tJTkRfQ09OVEFJTkVSX0NQVV9VVElMSVpBVElPThAuEh8KG01FVFJJQ19LSU5EX0RJU0tfVVNFRF9CWVRFUxAvEiQKIE1FVFJJQ19LSU5EX0RJU0tfQVZBSUxBQkxFX0JZVEVTEDASJwojTUVUUklDX0tJTkRfUkVTT0xWRVJfSU5WT0tFUl9ORVRfVFgQMRInCiNNRVRSSUNfS0lORF9SRVNPTFZFUl9JTlZPS0VSX05FVF9SWBAyEi0KKU1FVFJJQ19LSU5EX1JFU09MVkVSX0lOVk9LRVJfUk9XU19XUklUVEVOEDMSKAokTUVUUklDX0tJTkRfVE9QSUNfTUVTU0FHRVNfUFJPQ0VTU0VEEDQSMQotTUVUUklDX0tJTkRfU1VCU0NSSVBUSU9OX05VTV9VTkFDS0VEX01FU1NBR0VTEDUSNwozTUVUUklDX0tJTkRfU1VCU0NSSVBUSU9OX09MREVTVF9VTkFDS0VEX01FU1NBR0VfQUdFEDYSIAocTUVUUklDX0tJTkRfVE9QSUNfT0ZGU0VUX0xBRxA3Eh8KG01FVFJJQ19LSU5EX0dQVV9VVElMSVpBVElPThA4EiMKH01FVFJJQ19LSU5EX0dQVV9URU5TT1JfQUNUSVZJVFkQORIgChxNRVRSSUNfS0lORF9HUFVfU01fQ0xPQ0tfTUhaEDoSHwobTUVUUklDX0tJTkRfR1BVX1BPV0VSX1dBVFRTEDsSJwojTUVUUklDX0tJTkRfR1BVX1RFTVBFUkFUVVJFX0NFTFNJVVMQPBIkCiBNRVRSSUNfS0lORF9HUFVfVEhST1RUTEVfUkVBU09OUxA9EiEKHU1FVFJJQ19LSU5EX0dQVV9GUDE2X0FDVElWSVRZED4SGQoVTUVUUklDX0tJTkRfR1BVX0NPVU5UED8SJgoiTUVUUklDX0tJTkRfUFVMTF9RVUVSWV9RVUVVRV9ERVBUSBBAEi0KKU1FVFJJQ19LSU5EX1BVTExfUVVFUllfT0xERVNUX1VOQUNLRURfQUdFEEESJAogTUVUUklDX0tJTkRfUFVMTF9RVUVSWV9QUk9DRVNTRUQQQhIiCh5NRVRSSUNfS0lORF9QVUxMX1FVRVJZX0xBVEVOQ1kQQxIfChtNRVRSSUNfS0lORF9DT05UQUlORVJfQ09VTlQQRBIrCidNRVRSSUNfS0lORF9TQ0FMSU5HX0dST1VQX1JFUExJQ0FfQ09VTlQQRRInCiNNRVRSSUNfS0lORF9QVUxMX1FVRVJZX01BWF9JTkZMSUdIVBBGEi0KKU1FVFJJQ19LSU5EX1BVTExfUVVFUllfQ09OQ1VSUkVOQ1lfVEFSR0VUEEcSKwonTUVUUklDX0tJTkRfUFVMTF9RVUVSWV9PUEVOX0NPTk5FQ1RJT05TEEgSJgoiTUVUUklDX0tJTkRfRlVOQ1RJT05fQ0FMTF9FTlFVRVVFRBBJEi0KKU1FVFJJQ19LSU5EX0ZVTkNUSU9OX0NBTExfRU5RVUVVRV9MQVRFTkNZEEoSLgoqTUVUUklDX0tJTkRfRlVOQ1RJT05fQ0FMTF9PUEVOX0NPTk5FQ1RJT05TEEsSJgoiTUVUUklDX0tJTkRfRlVOQ1RJT05fQ0FMTF9ERVFVRVVFRBBMEjAKLE1FVFJJQ19LSU5EX0ZVTkNUSU9OX0NBTExfUFJPQ0VTU0lOR19MQVRFTkNZEE0SKQolTUVUUklDX0tJTkRfRlVOQ1RJT05fQ0FMTF9RVUVVRV9ERVBUSBBOEiYKIk1FVFJJQ19LSU5EX0ZVTkNUSU9OX0NBTExfSU5GTElHSFQQTxIqCiZNRVRSSUNfS0lORF9QT0RfQ09OVEFJTkVSX01FTU9SWV9CWVRFUxBQEi0KKU1FVFJJQ19LSU5EX1BPRF9DT05UQUlORVJfQ1BVX1VUSUxJWkFUSU9OEFESLworTUVUUklDX0tJTkRfUVVFUllfUFJPR1JFU1NfU1BMSVRTX1BST0NFU1NFRBBSEiwKKE1FVFJJQ19LSU5EX1FVRVJZX1BST0dSRVNTX1NQTElUU19RVUVVRUQQUxIuCipNRVRSSUNfS0lORF9RVUVSWV9QUk9HUkVTU19CTE9DS0VEX0RSSVZFUlMQVBI1CjFNRVRSSUNfS0lORF9RVUVSWV9QUk9HUkVTU19SRVNPTFZFUl9ST1dTX1JFVFVSTkVEEFUSNAowTUVUUklDX0tJTkRfUVVFUllfUFJPR1JFU1NfT1BFUkFUT1JfT1VUUFVUX0JZVEVTEFYSNgoyTUVUUklDX0tJTkRfUVVFUllfUFJPR1JFU1NfT1BFUkFUT1JfUk9XU19QUk9DRVNTRUQQVxIlCiFNRVRSSUNfS0lORF9TQ0hFRFVMRURfUVVFUllfQ09VTlQQWBItCilNRVRSSUNfS0lORF9TQ0hFRFVMRURfUVVFUllfU1VDQ0VTU19SQVRJTxBZEjQKME1FVFJJQ19LSU5EX0hZUEVSVklTT1JfQ09OVEFJTkVSX0NQVV9VVElMSVpBVElPThBaEjEKLU1FVFJJQ19LSU5EX0hZUEVSVklTT1JfQ09OVEFJTkVSX01FTU9SWV9CWVRFUxBbEiIKHk1FVFJJQ19LSU5EX1FVRVJZX1BMQU5fTEFURU5DWRBcEjIKLk1FVFJJQ19LSU5EX1FVRVJZX1BST0dSRVNTX1NQT09MX0ZMVVNIRURfQllURVMQXRI0CjBNRVRSSUNfS0lORF9RVUVSWV9QUk9HUkVTU19TUE9PTF9SRUNMQUlNRURfQllURVMQXhIzCi9NRVRSSUNfS0lORF9RVUVSWV9QUk9HUkVTU19TUE9PTF9CVUZGRVJFRF9CWVRFUxBfEjcKM01FVFJJQ19LSU5EX1FVRVJZX1BST0dSRVNTX1NQT09MX09VVFNUQU5ESU5HX0NIVU5LUxBgEiwKKE1FVFJJQ19LSU5EX1FVRVJZX1BST0dSRVNTX1NQSUxMRURfQllURVMQYRIrCidNRVRSSUNfS0lORF9RVUVSWV9QUk9HUkVTU19TUElMTEVEX1JPV1MQYhI2CjJNRVRSSUNfS0lORF9RVUVSWV9QUk9HUkVTU19TUElMTF9PVVRTVEFORElOR19CWVRFUxBjEiwKKE1FVFJJQ19LSU5EX1FVRVJZX1BST0dSRVNTX1NQSUxMX1RJTUVfTVMQZBIvCitNRVRSSUNfS0lORF9URUxFTUVUUllfUElQRUxJTkVfTE9HX1JFQ0VJVkVEEGUSLgoqTUVUUklDX0tJTkRfVEVMRU1FVFJZX1BJUEVMSU5FX0xPR19FTUlUVEVEEGYSLgoqTUVUUklDX0tJTkRfVEVMRU1FVFJZX1BJUEVMSU5FX0xPR19EUk9QUEVEEGcSMgouTUVUUklDX0tJTkRfVEVMRU1FVFJZX1BJUEVMSU5FX01FVFJJQ19SRUNFSVZFRBBoEjEKLU1FVFJJQ19LSU5EX1RFTEVNRVRSWV9QSVBFTElORV9NRVRSSUNfRU1JVFRFRBBpEjEKLU1FVFJJQ19LSU5EX1RFTEVNRVRSWV9QSVBFTElORV9NRVRSSUNfRFJPUFBFRBBqEjEKLU1FVFJJQ19LSU5EX1RFTEVNRVRSWV9QSVBFTElORV9UUkFDRV9SRUNFSVZFRBBrEjAKLE1FVFJJQ19LSU5EX1RFTEVNRVRSWV9QSVBFTElORV9UUkFDRV9FTUlUVEVEEGwSMAosTUVUUklDX0tJTkRfVEVMRU1FVFJZX1BJUEVMSU5FX1RSQUNFX0RST1BQRUQQbRIxCi1NRVRSSUNfS0lORF9URUxFTUVUUllfUElQRUxJTkVfTUlYRURfUkVDRUlWRUQQbhIwCixNRVRSSUNfS0lORF9URUxFTUVUUllfUElQRUxJTkVfTUlYRURfRU1JVFRFRBBvEjAKLE1FVFJJQ19LSU5EX1RFTEVNRVRSWV9QSVBFTElORV9NSVhFRF9EUk9QUEVEEHASJQohTUVUUklDX0tJTkRfR1BVX01FTU9SWV9VU0VEX0JZVEVTEHESJQohTUVUUklDX0tJTkRfR1BVX01FTU9SWV9GUkVFX0JZVEVTEHISLQopTUVUUklDX0tJTkRfTE9XX0NQVV9VVElMSVpBVElPTl9QT0RfQ09VTlQQcxIhCh1NRVRSSUNfS0lORF9ESVNLX1VTRURfUEVSQ0VOVBB0EicKI01FVFJJQ19LSU5EX0NMSUNLSE9VU0VfQ1BVX1BDVF9VU0VEEHUSKgomTUVUUklDX0tJTkRfQ0xJQ0tIT1VTRV9DUFVfU1lTVEVNX1RJTUUQdhIoCiRNRVRSSUNfS0lORF9DTElDS0hPVVNFX0NQVV9JRExFX1RJTUUQdxIoCiRNRVRSSUNfS0lORF9DTElDS0hPVVNFX0NQVV9VU0VSX1RJTUUQeBItCilNRVRSSUNfS0lORF9DTElDS0hPVVNFX01FTU9SWV9MSU1JVF9CWVRFUxB5EioKJk1FVFJJQ19LSU5EX0NMSUNLSE9VU0VfTUVNT1JZX1BDVF9VU0VEEHoSLAooTUVUUklDX0tJTkRfQ0xJQ0tIT1VTRV9NRU1PUllfVVNFRF9CWVRFUxB7EiYKIk1FVFJJQ19LSU5EX0NMSUNLSE9VU0VfUVVFUllfQ09VTlQQfBIvCitNRVRSSUNfS0lORF9DTElDS0hPVVNFX1FVRVJZX0xBVEVOQ1lfQVZHX01TEH0SLworTUVUUklDX0tJTkRfQ0xJQ0tIT1VTRV9RVUVSWV9MQVRFTkNZX01BWF9NUxB+EikKJU1FVFJJQ19LSU5EX09OTElORV9TVE9SRV9EQVRBU0VUX1NJWkUQfxIuCilNRVRSSUNfS0lORF9PTkxJTkVfU1RPUkVfQUxMT0NBVEVEX01FTU9SWRCAARIqCiVNRVRSSUNfS0lORF9PRkZMSU5FX1NUT1JFX1RPVEFMX0JZVEVTEIEBEikKJE1FVFJJQ19LSU5EX09GRkxJTkVfU1RPUkVfV0lERV9CWVRFUxCCARIzCi5NRVRSSUNfS0lORF9TVFJFQU1fTUVTU0FHRV9QUk9DRVNTSU5HX0RVUkFUSU9OEIMBEigKI01FVFJJQ19LSU5EX09GRkxJTkVfUVVFUllfQ09NUExFVEVEEIQBEioKJU1FVFJJQ19LSU5EX09GRkxJTkVfUVVFUllfQUNDRUxFUkFURUQQhQESKAojTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfQUNDVVJBQ1kQhgESJAofTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfTE9TUxCHARIpCiRNRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19QUkVDSVNJT04QiAESJgohTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfUkVDQUxMEIkBEiIKHU1FVFJJQ19LSU5EX01PREVMX1RSQUlOSU5HX0YxEIoBEiMKHk1FVFJJQ19LSU5EX01PREVMX1RSQUlOSU5HX01BRRCLARIjCh5NRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19NU0UQjAESJAofTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfUk1TRRCNARIiCh1NRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19SMhCOARItCihNRVRSSUNfS0lORF9FTlZPWV9VUFNUUkVBTV9SRVFVRVNUX0NPVU5UEI8BEiAKG01FVFJJQ19LSU5EX1BPRF9TVEFURV9DT1VOVBCQARIiCh1NRVRSSUNfS0lORF9DT05UQUlORVJfQ1JBU0hFUxCRARImCiFNRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19SRVdBUkQQkgESKgolTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfUkVXQVJEX1NURBCTARIpCiRNRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19QQVNTX1JBVEUQlAESIgodTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfS0wQlQESJwoiTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfRU5UUk9QWRCWARIpCiRNRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19HUkFEX05PUk0QlwESLQooTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfTEVBUk5JTkdfUkFURRCYARIvCipNRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19SRVNQT05TRV9MRU5HVEgQmQESKwomTUVUUklDX0tJTkRfTU9ERUxfVFJBSU5JTkdfTUlTTUFUQ0hfS0wQqQESJAofTUVUUklDX0tJTkRfU0FOREJPWF9TVEFURV9DT1VOVBCaARIoCiNNRVRSSUNfS0lORF9TQU5EQk9YX1NUQVJUVVBfTEFURU5DWRCbARIqCiVNRVRSSUNfS0lORF9TQU5EQk9YX01FTU9SWV9VU0VEX0JZVEVTEJwBEigKI01FVFJJQ19LSU5EX1NBTkRCT1hfQ1BVX1VTQUdFX0NPUkVTEJ0BEioKJU1FVFJJQ19LSU5EX1NBTkRCT1hfQ1BVX1JFUVVFU1RfQ09SRVMQngESLQooTUVUUklDX0tJTkRfU0FOREJPWF9NRU1PUllfUkVRVUVTVF9CWVRFUxCfARIoCiNNRVRSSUNfS0lORF9TQU5EQk9YX0NQVV9VVElMSVpBVElPThCgARIrCiZNRVRSSUNfS0lORF9TQU5EQk9YX01FTU9SWV9VVElMSVpBVElPThChARItCihNRVRSSUNfS0lORF9NT0RFTF9UUkFJTklOR19SVUJSSUNfUkVXQVJEEKIBEisKJk1FVFJJQ19LSU5EX01PREVMX1RSQUlOSU5HX1RBU0tfUkVXQVJEEKMBEjEKLE1FVFJJQ19LSU5EX1ZJQ1RPUklBX01FVFJJQ1NfRElTS19VU0VEX0JZVEVTEKQBEjEKLE1FVFJJQ19LSU5EX1ZJQ1RPUklBX01FVFJJQ1NfRElTS19GUkVFX0JZVEVTEKUBEjIKLU1FVFJJQ19LSU5EX1ZJQ1RPUklBX01FVFJJQ1NfRElTS19UT1RBTF9CWVRFUxCmARIbChZNRVRSSUNfS0lORF9RVUVSWV9SQVRFEKcBEiQKH01FVFJJQ19LSU5EX1NUUkVBTV9NRVNTQUdFX1JBVEUQqAESLQooTUVUUklDX0tJTkRfRlVOQ1RJT05fQ0FMTF9RVUVVRV9EVVJBVElPThCqASqUDQoKRmlsdGVyS2luZBIbChdGSUxURVJfS0lORF9VTlNQRUNJRklFRBAAEh4KGkZJTFRFUl9LSU5EX0ZFQVRVUkVfU1RBVFVTEAESHAoYRklMVEVSX0tJTkRfRkVBVFVSRV9OQU1FEAISGwoXRklMVEVSX0tJTkRfRkVBVFVSRV9UQUcQAxIfChtGSUxURVJfS0lORF9SRVNPTFZFUl9TVEFUVVMQBBIdChlGSUxURVJfS0lORF9SRVNPTFZFUl9OQU1FEAUSHAoYRklMVEVSX0tJTkRfUkVTT0xWRVJfVEFHEAYSGwoXRklMVEVSX0tJTkRfQ1JPTl9TVEFUVVMQBxIgChxGSUxURVJfS0lORF9NSUdSQVRJT05fU1RBVFVTEAgSHgoaRklMVEVSX0tJTkRfT05MSU5FX09GRkxJTkUQCRIZChVGSUxURVJfS0lORF9DQUNIRV9ISVQQChIcChhGSUxURVJfS0lORF9PUEVSQVRJT05fSUQQCxIaChZGSUxURVJfS0lORF9RVUVSWV9OQU1FEAwSHAoYRklMVEVSX0tJTkRfUVVFUllfU1RBVFVTEA0SFwoTRklMVEVSX0tJTkRfSVNfTlVMTBAOEhoKFkZJTFRFUl9LSU5EX1VTQUdFX0tJTkQQDxIeChpGSUxURVJfS0lORF9SRVNPVVJDRV9HUk9VUBAQEhgKFEZJTFRFUl9LSU5EX1BPRF9OQU1FEBESIwofRklMVEVSX0tJTkRfQ09NUFVUQVRJT05fQ09OVEVYVBASEhoKFkZJTFRFUl9LSU5EX1RPUElDX05BTUUQExIhCh1GSUxURVJfS0lORF9TVUJTQ1JJUFRJT05fTkFNRRAUEh4KGkZJTFRFUl9LSU5EX1BBUlRJVElPTl9OQU1FEBUSHQoZRklMVEVSX0tJTkRfU0NBTElOR19HUk9VUBAWEh0KGUZJTFRFUl9LSU5EX0ZVTkNUSU9OX05BTUUQFxIcChhGSUxURVJfS0lORF9TRVJWSUNFX0tJTkQQGBIeChpGSUxURVJfS0lORF9DT05TVU1FUl9HUk9VUBAZEhwKGEZJTFRFUl9LSU5EX0NPTlRBSU5FUl9JRBAaEhcKE0ZJTFRFUl9LSU5EX1BMQU5ORVIQGxIbChdGSUxURVJfS0lORF9QTEFOX1JFQVNPThAcEiIKHkZJTFRFUl9LSU5EX0ZVTkNUSU9OX0NBTExfTU9ERRAdEioKJkZJTFRFUl9LSU5EX09GRkxJTkVfUVVFUllfT1BFUkFUSU9OX0lEEB4SKAokRklMVEVSX0tJTkRfU0NSSVBUX1RBU0tfT1BFUkFUSU9OX0lEEB8SIQodRklMVEVSX0tJTkRfQ1JPTl9PUEVSQVRJT05fSUQQIBIlCiFGSUxURVJfS0lORF9DSEFMS1NRTF9PUEVSQVRJT05fSUQQIRIZChVGSUxURVJfS0lORF9OT0RFX05BTUUQIhIpCiVGSUxURVJfS0lORF9TQ0FMSU5HX0dST1VQX1JFVklTSU9OX0lEECMSGQoVRklMVEVSX0tJTkRfTkFNRVNQQUNFECQSHwobRklMVEVSX0tJTkRfVFJBSU5JTkdfUlVOX0lEECUSHQoZRklMVEVSX0tJTkRfVFJBSU5JTkdfU1RFUBAmEh4KGkZJTFRFUl9LSU5EX1RSQUlOSU5HX1NQTElUECcSHgoaRklMVEVSX0tJTkRfVFJBSU5JTkdfQ0xBU1MQKBIiCh5GSUxURVJfS0lORF9UUkFJTklOR19USFJFU0hPTEQQKRIiCh5GSUxURVJfS0lORF9UUkFJTklOR19PUFRJTUlaRVIQKhImCiJGSUxURVJfS0lORF9UUkFJTklOR19NT0RFTF9WRVJTSU9OECsSHgoaRklMVEVSX0tJTkRfVFJBSU5JTkdfRVBPQ0gQLBIZChVGSUxURVJfS0lORF9QT0RfU1RBVEUQLRImCiJGSUxURVJfS0lORF9DT05UQUlORVJfQ1JBU0hfUkVBU09OEC4SIAocRklMVEVSX0tJTkRfV09SS0xPQURfUlVOVElNRRAwEh4KGkZJTFRFUl9LSU5EX1dPUktMT0FEX1NUQVRFEDESHwobRklMVEVSX0tJTkRfVFJBSU5JTkdfUlVCUklDEDISHQoZRklMVEVSX0tJTkRfVFJBSU5JTkdfVEFTSxAzEhsKF0ZJTFRFUl9LSU5EX1dPUktMT0FEX0lEEDQiBAgvEC8qfgoOQ29tcGFyYXRvcktpbmQSHwobQ09NUEFSQVRPUl9LSU5EX1VOU1BFQ0lGSUVEEAASFgoSQ09NUEFSQVRPUl9LSU5EX0VREAESFwoTQ09NUEFSQVRPUl9LSU5EX05FURACEhoKFkNPTVBBUkFUT1JfS0lORF9PTkVfT0YQAyrsAwoSV2luZG93RnVuY3Rpb25LaW5kEiQKIFdJTkRPV19GVU5DVElPTl9LSU5EX1VOU1BFQ0lGSUVEEAASHgoaV0lORE9XX0ZVTkNUSU9OX0tJTkRfQ09VTlQQARIdChlXSU5ET1dfRlVOQ1RJT05fS0lORF9NRUFOEAISHAoYV0lORE9XX0ZVTkNUSU9OX0tJTkRfU1VNEAMSHAoYV0lORE9XX0ZVTkNUSU9OX0tJTkRfTUlOEAQSHAoYV0lORE9XX0ZVTkNUSU9OX0tJTkRfTUFYEAUSJgoiV0lORE9XX0ZVTkNUSU9OX0tJTkRfUEVSQ0VOVElMRV85ORAGEiYKIldJTkRPV19GVU5DVElPTl9LSU5EX1BFUkNFTlRJTEVfOTUQBxImCiJXSU5ET1dfRlVOQ1RJT05fS0lORF9QRVJDRU5USUxFXzc1EAgSJgoiV0lORE9XX0ZVTkNUSU9OX0tJTkRfUEVSQ0VOVElMRV81MBAJEiYKIldJTkRPV19GVU5DVElPTl9LSU5EX1BFUkNFTlRJTEVfMjUQChIlCiFXSU5ET1dfRlVOQ1RJT05fS0lORF9QRVJDRU5USUxFXzUQCxIoCiRXSU5ET1dfRlVOQ1RJT05fS0lORF9BTExfUEVSQ0VOVElMRVMQDCreDAoLR3JvdXBCeUtpbmQSHQoZR1JPVVBfQllfS0lORF9VTlNQRUNJRklFRBAAEiAKHEdST1VQX0JZX0tJTkRfRkVBVFVSRV9TVEFUVVMQARIeChpHUk9VUF9CWV9LSU5EX0ZFQVRVUkVfTkFNRRACEhkKFUdST1VQX0JZX0tJTkRfSVNfTlVMTBADEiEKHUdST1VQX0JZX0tJTkRfUkVTT0xWRVJfU1RBVFVTEAQSHwobR1JPVVBfQllfS0lORF9SRVNPTFZFUl9OQU1FEAUSHgoaR1JPVVBfQllfS0lORF9RVUVSWV9TVEFUVVMQBhIcChhHUk9VUF9CWV9LSU5EX1FVRVJZX05BTUUQBxIgChxHUk9VUF9CWV9LSU5EX09OTElORV9PRkZMSU5FEAgSGwoXR1JPVVBfQllfS0lORF9DQUNIRV9ISVQQCRIcChhHUk9VUF9CWV9LSU5EX1VTQUdFX0tJTkQQChIgChxHUk9VUF9CWV9LSU5EX1JFU09VUkNFX0dST1VQEAsSHwobR1JPVVBfQllfS0lORF9ERVBMT1lNRU5UX0lEEAwSHgoaR1JPVVBfQllfS0lORF9PUEVSQVRJT05fSUQQDRIaChZHUk9VUF9CWV9LSU5EX1BPRF9OQU1FEA4SHAoYR1JPVVBfQllfS0lORF9UT1BJQ19OQU1FEA8SIwofR1JPVVBfQllfS0lORF9TVUJTQ1JJUFRJT05fTkFNRRAQEiAKHEdST1VQX0JZX0tJTkRfUEFSVElUSU9OX05BTUUQERIfChtHUk9VUF9CWV9LSU5EX0ZVTkNUSU9OX05BTUUQEhIeChpHUk9VUF9CWV9LSU5EX1NFUlZJQ0VfS0lORBATEiAKHEdST1VQX0JZX0tJTkRfQ09OU1VNRVJfR1JPVVAQFBIZChVHUk9VUF9CWV9LSU5EX1BMQU5ORVIQFRIdChlHUk9VUF9CWV9LSU5EX1BMQU5fUkVBU09OEBYSKQolR1JPVVBfQllfS0lORF9URUxFTUVUUllfUElQRUxJTkVfUk9MRRAXEikKJUdST1VQX0JZX0tJTkRfVEVMRU1FVFJZX1BJUEVMSU5FX1NURVAQGBIvCitHUk9VUF9CWV9LSU5EX1RFTEVNRVRSWV9QSVBFTElORV9EUk9QX1NDT1BFEBkSLAooR1JPVVBfQllfS0lORF9PRkZMSU5FX1FVRVJZX09QRVJBVElPTl9JRBAaEioKJkdST1VQX0JZX0tJTkRfU0NSSVBUX1RBU0tfT1BFUkFUSU9OX0lEEBsSIwofR1JPVVBfQllfS0lORF9DUk9OX09QRVJBVElPTl9JRBAcEicKI0dST1VQX0JZX0tJTkRfQ0hBTEtTUUxfT1BFUkFUSU9OX0lEEB0SKwonR1JPVVBfQllfS0lORF9TQ0FMSU5HX0dST1VQX1JFVklTSU9OX0lEEB4SGwoXR1JPVVBfQllfS0lORF9OQU1FU1BBQ0UQHxIhCh1HUk9VUF9CWV9LSU5EX1RSQUlOSU5HX1JVTl9JRBAgEh8KG0dST1VQX0JZX0tJTkRfVFJBSU5JTkdfU1RFUBAhEiAKHEdST1VQX0JZX0tJTkRfVFJBSU5JTkdfU1BMSVQQIhIgChxHUk9VUF9CWV9LSU5EX1RSQUlOSU5HX0NMQVNTECMSJAogR1JPVVBfQllfS0lORF9UUkFJTklOR19USFJFU0hPTEQQJBIkCiBHUk9VUF9CWV9LSU5EX1RSQUlOSU5HX09QVElNSVpFUhAlEigKJEdST1VQX0JZX0tJTkRfVFJBSU5JTkdfTU9ERUxfVkVSU0lPThAmEiAKHEdST1VQX0JZX0tJTkRfVFJBSU5JTkdfRVBPQ0gQJxIfChtHUk9VUF9CWV9LSU5EX0VOVk9ZX0NMVVNURVIQKBIbChdHUk9VUF9CWV9LSU5EX1BPRF9TVEFURRApEigKJEdST1VQX0JZX0tJTkRfQ09OVEFJTkVSX0NSQVNIX1JFQVNPThAqEiIKHkdST1VQX0JZX0tJTkRfV09SS0xPQURfUlVOVElNRRAsEiEKHUdST1VQX0JZX0tJTkRfVFJBSU5JTkdfUlVCUklDEC4SHwobR1JPVVBfQllfS0lORF9UUkFJTklOR19UQVNLEC8iBAgrECsiBAgtEC0qgQMKEU1ldHJpY0Zvcm11bGFLaW5kEiMKH01FVFJJQ19GT1JNVUxBX0tJTkRfVU5TUEVDSUZJRUQQABIbChdNRVRSSUNfRk9STVVMQV9LSU5EX1NVTRABEiMKH01FVFJJQ19GT1JNVUxBX0tJTkRfVE9UQUxfUkFUSU8QAhIdChlNRVRSSUNfRk9STVVMQV9LSU5EX1JBVElPEAMSHwobTUVUUklDX0ZPUk1VTEFfS0lORF9QUk9EVUNUEAQSGwoXTUVUUklDX0ZPUk1VTEFfS0lORF9BQlMQBRIfChtNRVRSSUNfRk9STVVMQV9LSU5EX0tTX1NUQVQQBhIfChtNRVRSSUNfRk9STVVMQV9LSU5EX0tTX1RFU1QQBxIkCiBNRVRSSUNfRk9STVVMQV9LSU5EX0tTX1RIUkVTSE9MRBAIEiMKH01FVFJJQ19GT1JNVUxBX0tJTkRfVElNRV9PRkZTRVQQCRIbChdNRVRSSUNfRk9STVVMQV9LSU5EX1NVQhAKKtoBChFBbGVydFNldmVyaXR5S2luZBIjCh9BTEVSVF9TRVZFUklUWV9LSU5EX1VOU1BFQ0lGSUVEEAASIAocQUxFUlRfU0VWRVJJVFlfS0lORF9DUklUSUNBTBABEh0KGUFMRVJUX1NFVkVSSVRZX0tJTkRfRVJST1IQAhIfChtBTEVSVF9TRVZFUklUWV9LSU5EX1dBUk5JTkcQAxIcChhBTEVSVF9TRVZFUklUWV9LSU5EX0lORk8QBBIgChxBTEVSVF9TRVZFUklUWV9LSU5EX1JFU09MVkVEEAUq3AEKDVRocmVzaG9sZEtpbmQSHgoaVEhSRVNIT0xEX0tJTkRfVU5TUEVDSUZJRUQQABIYChRUSFJFU0hPTERfS0lORF9BQk9WRRABEhgKFFRIUkVTSE9MRF9LSU5EX0JFTE9XEAISIAocVEhSRVNIT0xEX0tJTkRfR1JFQVRFUl9FUVVBTBADEh0KGVRIUkVTSE9MRF9LSU5EX0xFU1NfRVFVQUwQBBIYChRUSFJFU0hPTERfS0lORF9FUVVBTBAFEhwKGFRIUkVTSE9MRF9LSU5EX05PVF9FUVVBTBAGKscBCg1DaGFydExpbmtLaW5kEh8KG0NIQVJUX0xJTktfS0lORF9VTlNQRUNJRklFRBAAEhwKGENIQVJUX0xJTktfS0lORF9SRVNPTFZFUhABEhsKF0NIQVJUX0xJTktfS0lORF9GRUFUVVJFEAISGQoVQ0hBUlRfTElOS19LSU5EX1FVRVJZEAMSGgoWQ0hBUlRfTElOS19LSU5EX01BTlVBTBAEEiMKH0NIQVJUX0xJTktfS0lORF9TQ0hFRFVMRURfUVVFUlkQBSrLAQoSUmF3TWV0cmljVmFsdWVLaW5kEiUKIVJBV19NRVRSSUNfVkFMVUVfS0lORF9VTlNQRUNJRklFRBAAEh8KG1JBV19NRVRSSUNfVkFMVUVfS0lORF9HQVVHRRABEiEKHVJBV19NRVRSSUNfVkFMVUVfS0lORF9DT1VOVEVSEAISIwofUkFXX01FVFJJQ19WQUxVRV9LSU5EX0hJU1RPR1JBTRADEiUKIVJBV19NRVRSSUNfVkFMVUVfS0lORF9ERUxUQV9DT1VOVBAEYgZwcm90bzM=", [file_google_protobuf_duration]);

/**
 * @generated from message chalk.artifacts.v1.AlertTrigger
 */
export type AlertTrigger = Message<"chalk.artifacts.v1.AlertTrigger"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: chalk.artifacts.v1.AlertSeverityKind severity = 2;
   */
  severity: AlertSeverityKind;

  /**
   * @generated from field: chalk.artifacts.v1.ThresholdKind threshold_position = 3;
   */
  thresholdPosition: ThresholdKind;

  /**
   * @generated from field: float threshold_value = 4;
   */
  thresholdValue: number;

  /**
   * @generated from field: optional string series_name = 5;
   */
  seriesName?: string;

  /**
   * @generated from field: optional string channel_name = 6;
   */
  channelName?: string;

  /**
   * @generated from field: optional string description = 7;
   */
  description?: string;
};

/**
 * Describes the message chalk.artifacts.v1.AlertTrigger.
 * Use `create(AlertTriggerSchema)` to create a new message.
 */
export const AlertTriggerSchema: GenMessage<AlertTrigger> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 0);

/**
 * @generated from message chalk.artifacts.v1.DatasetFeatureOperand
 */
export type DatasetFeatureOperand = Message<"chalk.artifacts.v1.DatasetFeatureOperand"> & {
  /**
   * @generated from field: string dataset = 1;
   */
  dataset: string;

  /**
   * @generated from field: string feature = 2;
   */
  feature: string;

  /**
   * Dataset revision (offline query id) to use as the KS baseline distribution.
   * When unset, the most recent revision for the dataset is used.
   *
   * @generated from field: optional string revision_id = 3;
   */
  revisionId?: string;
};

/**
 * Describes the message chalk.artifacts.v1.DatasetFeatureOperand.
 * Use `create(DatasetFeatureOperandSchema)` to create a new message.
 */
export const DatasetFeatureOperandSchema: GenMessage<DatasetFeatureOperand> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 1);

/**
 * @generated from message chalk.artifacts.v1.MetricFormula
 */
export type MetricFormula = Message<"chalk.artifacts.v1.MetricFormula"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricFormulaKind kind = 1;
   */
  kind: MetricFormulaKind;

  /**
   * The following fields are mutually exclusive
   * but we're not using `oneof` because one of
   * the fields is a repeated field, which would
   * make using `oneof` really ugly.
   * ---- UNION START ----
   *
   * @generated from field: optional int64 single_series_operands = 2;
   */
  singleSeriesOperands?: bigint;

  /**
   * @generated from field: repeated int64 multi_series_operands = 3;
   */
  multiSeriesOperands: bigint[];

  /**
   * @generated from field: chalk.artifacts.v1.DatasetFeatureOperand dataset_feature_operands = 4;
   */
  datasetFeatureOperands?: DatasetFeatureOperand;

  /**
   * ---- UNION END ----
   *
   * @generated from field: optional string name = 5;
   */
  name?: string;
};

/**
 * Describes the message chalk.artifacts.v1.MetricFormula.
 * Use `create(MetricFormulaSchema)` to create a new message.
 */
export const MetricFormulaSchema: GenMessage<MetricFormula> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 2);

/**
 * @generated from message chalk.artifacts.v1.MetricFilter
 */
export type MetricFilter = Message<"chalk.artifacts.v1.MetricFilter"> & {
  /**
   * @generated from field: chalk.artifacts.v1.FilterKind kind = 1;
   */
  kind: FilterKind;

  /**
   * @generated from field: chalk.artifacts.v1.ComparatorKind comparator = 2;
   */
  comparator: ComparatorKind;

  /**
   * @generated from field: repeated string value = 3;
   */
  value: string[];
};

/**
 * Describes the message chalk.artifacts.v1.MetricFilter.
 * Use `create(MetricFilterSchema)` to create a new message.
 */
export const MetricFilterSchema: GenMessage<MetricFilter> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 3);

/**
 * RawMetricLabelMatcher constrains a raw VictoriaMetrics label to a set of values.
 * Unlike MetricFilter it names the VM label directly, because raw series are not
 * mapped through the MetricKind registry and so have no FilterKind vocabulary.
 *
 * @generated from message chalk.artifacts.v1.RawMetricLabelMatcher
 */
export type RawMetricLabelMatcher = Message<"chalk.artifacts.v1.RawMetricLabelMatcher"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: chalk.artifacts.v1.ComparatorKind comparator = 2;
   */
  comparator: ComparatorKind;

  /**
   * @generated from field: repeated string value = 3;
   */
  value: string[];
};

/**
 * Describes the message chalk.artifacts.v1.RawMetricLabelMatcher.
 * Use `create(RawMetricLabelMatcherSchema)` to create a new message.
 */
export const RawMetricLabelMatcherSchema: GenMessage<RawMetricLabelMatcher> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 4);

/**
 * RawMetricSeries plots a VictoriaMetrics series by its own name and labels,
 * bypassing the curated MetricKind registry. It exists so Chalk employees can
 * introspect and chart metrics the registry does not (yet) map; see
 * ChartsService.ListRawMetrics for discovery.
 *
 * Access is Chalk-employee-only (PERMISSION_CHALK_ADMIN, enforced in the chart
 * snapshot handler) and raw series are rejected on the chart/alert persistence
 * paths: VM series names are an internal implementation detail, not a stable
 * surface a saved chart should depend on.
 *
 * @generated from message chalk.artifacts.v1.RawMetricSeries
 */
export type RawMetricSeries = Message<"chalk.artifacts.v1.RawMetricSeries"> & {
  /**
   * VictoriaMetrics series name, e.g. "chalk_query_plan_latency_bucket". Ignored
   * when metricsql is set.
   *
   * @generated from field: string metric_name = 1;
   */
  metricName: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.RawMetricLabelMatcher matchers = 2;
   */
  matchers: RawMetricLabelMatcher[];

  /**
   * Raw VM label names to group by. Each becomes a `by (...)` label and shows up
   * as a series tag under its own label name.
   *
   * @generated from field: repeated string group_by = 3;
   */
  groupBy: string[];

  /**
   * Fully free-form MetricsQL, evaluated verbatim as a range query. When set,
   * metric_name/matchers/group_by are ignored and no environment scoping is
   * injected, so the query must scope itself.
   *
   * @generated from field: optional string metricsql = 4;
   */
  metricsql?: string;

  /**
   * Overrides how metric_name is aggregated over each chart bucket. When unset,
   * the shape is inferred from the series name (a _bucket suffix means a
   * histogram, _total a cumulative counter, anything else a gauge).
   *
   * @generated from field: optional chalk.artifacts.v1.RawMetricValueKind value_kind = 5;
   */
  valueKind?: RawMetricValueKind;
};

/**
 * Describes the message chalk.artifacts.v1.RawMetricSeries.
 * Use `create(RawMetricSeriesSchema)` to create a new message.
 */
export const RawMetricSeriesSchema: GenMessage<RawMetricSeries> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 5);

/**
 * @generated from message chalk.artifacts.v1.MetricConfigSeries
 */
export type MetricConfigSeries = Message<"chalk.artifacts.v1.MetricConfigSeries"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricKind metric = 1;
   */
  metric: MetricKind;

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricFilter filters = 2;
   */
  filters: MetricFilter[];

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: chalk.artifacts.v1.WindowFunctionKind window_function = 4;
   */
  windowFunction: WindowFunctionKind;

  /**
   * @generated from field: repeated chalk.artifacts.v1.GroupByKind group_by = 5;
   */
  groupBy: GroupByKind[];

  /**
   * A positive duration by which to shift the time series data backwards.
   *
   * @generated from field: optional google.protobuf.Duration time_shift = 6;
   */
  timeShift?: Duration;

  /**
   * When set, this series plots a raw VictoriaMetrics series and `metric`,
   * `filters` and `group_by` are ignored. Chalk-employee-only; see RawMetricSeries.
   *
   * @generated from field: optional chalk.artifacts.v1.RawMetricSeries raw = 7;
   */
  raw?: RawMetricSeries;
};

/**
 * Describes the message chalk.artifacts.v1.MetricConfigSeries.
 * Use `create(MetricConfigSeriesSchema)` to create a new message.
 */
export const MetricConfigSeriesSchema: GenMessage<MetricConfigSeries> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 6);

/**
 * Marks a time-series (not statistic) config. Empty for now — the render fields
 * (display_window_period) stay at the MetricConfig top level.
 *
 * @generated from message chalk.artifacts.v1.TimeSeriesVisualizationOptions
 */
export type TimeSeriesVisualizationOptions = Message<"chalk.artifacts.v1.TimeSeriesVisualizationOptions"> & {
};

/**
 * Describes the message chalk.artifacts.v1.TimeSeriesVisualizationOptions.
 * Use `create(TimeSeriesVisualizationOptionsSchema)` to create a new message.
 */
export const TimeSeriesVisualizationOptionsSchema: GenMessage<TimeSeriesVisualizationOptions> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 7);

/**
 * When set on a MetricConfig, GetChartSnapshot evaluates the query over the whole range as a single
 * bucket and returns that scalar (GetChartSnapshotResponse.statistic) instead of a time series. The
 * series' own window_function is the aggregation (count/mean/max/…), so there is no separate
 * reduction or bucketing knob. The config must produce exactly one output series (no group_by, no
 * multiple series/formulas).
 *
 * @generated from message chalk.artifacts.v1.StatisticVisualizationOptions
 */
export type StatisticVisualizationOptions = Message<"chalk.artifacts.v1.StatisticVisualizationOptions"> & {
};

/**
 * Describes the message chalk.artifacts.v1.StatisticVisualizationOptions.
 * Use `create(StatisticVisualizationOptionsSchema)` to create a new message.
 */
export const StatisticVisualizationOptionsSchema: GenMessage<StatisticVisualizationOptions> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 8);

/**
 * @generated from message chalk.artifacts.v1.MetricConfig
 */
export type MetricConfig = Message<"chalk.artifacts.v1.MetricConfig"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Lookback window evaluated by the alerting/monitor system. Not used for chart rendering.
   * Encoded as a chalk duration string (e.g. "5m", "1h").
   *
   * @generated from field: string window_period = 2;
   */
  windowPeriod: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricConfigSeries series = 3;
   */
  series: MetricConfigSeries[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricFormula formulas = 4;
   */
  formulas: MetricFormula[];

  /**
   * @generated from field: repeated string mql_formulas = 11;
   */
  mqlFormulas: string[];

  /**
   * @generated from field: chalk.artifacts.v1.AlertTrigger trigger = 5;
   */
  trigger?: AlertTrigger;

  /**
   * If this is generated as part of their code source and not to be edited otherwise
   *
   * @generated from field: bool graph_generated = 6;
   */
  graphGenerated: boolean;

  /**
   * important: different from chart id! standalone, referenced as "metric config id"
   *
   * @generated from field: string id = 7;
   */
  id: string;

  /**
   * Bucket size used when rendering this metric as a chart in the UI. When unset, the
   * frontend selects a sensible default based on the requested time range. Independent
   * of `window_period`, which is alert-only. Encoded as a chalk duration string (e.g.
   * "5m", "1h").
   *
   * @generated from field: optional string display_window_period = 8;
   */
  displayWindowPeriod?: string;

  /**
   * Which visualization this config renders as; unset is treated as a time series.
   *
   * @generated from oneof chalk.artifacts.v1.MetricConfig.visualization_options
   */
  visualizationOptions: {
    /**
     * @generated from field: chalk.artifacts.v1.TimeSeriesVisualizationOptions time_series_options = 9;
     */
    value: TimeSeriesVisualizationOptions;
    case: "timeSeriesOptions";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.StatisticVisualizationOptions stat_options = 10;
     */
    value: StatisticVisualizationOptions;
    case: "statOptions";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.artifacts.v1.MetricConfig.
 * Use `create(MetricConfigSchema)` to create a new message.
 */
export const MetricConfigSchema: GenMessage<MetricConfig> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 9);

/**
 * @generated from message chalk.artifacts.v1.Chart
 */
export type Chart = Message<"chalk.artifacts.v1.Chart"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: chalk.artifacts.v1.MetricConfig config = 2;
   */
  config?: MetricConfig;

  /**
   * @generated from field: chalk.artifacts.v1.ChartLinkKind entity_kind = 3;
   */
  entityKind: ChartLinkKind;

  /**
   * @generated from field: optional string entity_id = 4;
   */
  entityId?: string;

  /**
   * If this is generated as part of their code source and not to be edited otherwise
   *
   * @generated from field: bool graph_generated = 5;
   */
  graphGenerated: boolean;

  /**
   * True if this chart has not yet been persisted to the database.
   * Virtual charts are computed on the fly by ListCharts when no DB-backed charts exist
   * for the given entity. Saving a virtual chart creates it (and any siblings) via CreateChart.
   *
   * @generated from field: bool is_virtual = 6;
   */
  isVirtual: boolean;
};

/**
 * Describes the message chalk.artifacts.v1.Chart.
 * Use `create(ChartSchema)` to create a new message.
 */
export const ChartSchema: GenMessage<Chart> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_chart, 10);

/**
 * @generated from enum chalk.artifacts.v1.MetricKind
 */
export enum MetricKind {
  /**
   * @generated from enum value: METRIC_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_REQUEST_COUNT = 1;
   */
  FEATURE_REQUEST_COUNT = 1,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_LATENCY = 2;
   */
  FEATURE_LATENCY = 2,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_STALENESS = 3;
   */
  FEATURE_STALENESS = 3,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_VALUE = 4;
   */
  FEATURE_VALUE = 4,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_WRITE = 5;
   */
  FEATURE_WRITE = 5,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_NULL_RATIO = 6;
   */
  FEATURE_NULL_RATIO = 6,

  /**
   * @generated from enum value: METRIC_KIND_RESOLVER_REQUEST_COUNT = 7;
   */
  RESOLVER_REQUEST_COUNT = 7,

  /**
   * @generated from enum value: METRIC_KIND_RESOLVER_LATENCY = 8;
   */
  RESOLVER_LATENCY = 8,

  /**
   * @generated from enum value: METRIC_KIND_RESOLVER_SUCCESS_RATIO = 9;
   */
  RESOLVER_SUCCESS_RATIO = 9,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_COUNT = 10;
   */
  QUERY_COUNT = 10,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_LATENCY = 11;
   */
  QUERY_LATENCY = 11,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_SUCCESS_RATIO = 12;
   */
  QUERY_SUCCESS_RATIO = 12,

  /**
   * @generated from enum value: METRIC_KIND_BILLING_INFERENCE = 13;
   */
  BILLING_INFERENCE = 13,

  /**
   * @generated from enum value: METRIC_KIND_BILLING_CRON = 14;
   */
  BILLING_CRON = 14,

  /**
   * @generated from enum value: METRIC_KIND_BILLING_MIGRATION = 15;
   */
  BILLING_MIGRATION = 15,

  /**
   * @generated from enum value: METRIC_KIND_CRON_COUNT = 16;
   */
  CRON_COUNT = 16,

  /**
   * @generated from enum value: METRIC_KIND_CRON_LATENCY = 17;
   */
  CRON_LATENCY = 17,

  /**
   * @generated from enum value: METRIC_KIND_STREAM_MESSAGES_PROCESSED = 18;
   */
  STREAM_MESSAGES_PROCESSED = 18,

  /**
   * @generated from enum value: METRIC_KIND_STREAM_MESSAGE_LATENCY = 19;
   */
  STREAM_MESSAGE_LATENCY = 19,

  /**
   * @generated from enum value: METRIC_KIND_STREAM_WINDOWS_PROCESSED = 20;
   */
  STREAM_WINDOWS_PROCESSED = 20,

  /**
   * @generated from enum value: METRIC_KIND_STREAM_WINDOW_LATENCY = 21;
   */
  STREAM_WINDOW_LATENCY = 21,

  /**
   * @generated from enum value: METRIC_KIND_ONLINE_STORE_KEY_COUNT = 22;
   */
  ONLINE_STORE_KEY_COUNT = 22,

  /**
   * @generated from enum value: METRIC_KIND_ONLINE_STORE_EXPIRED_KEY_COUNT = 23;
   */
  ONLINE_STORE_EXPIRED_KEY_COUNT = 23,

  /**
   * @generated from enum value: METRIC_KIND_ONLINE_STORE_REQUESTS_PER_SECOND = 24;
   */
  ONLINE_STORE_REQUESTS_PER_SECOND = 24,

  /**
   * @generated from enum value: METRIC_KIND_CPU_UTILIZATION_PERCENT = 25;
   */
  CPU_UTILIZATION_PERCENT = 25,

  /**
   * @generated from enum value: METRIC_KIND_REPLICA_COUNT = 26;
   */
  REPLICA_COUNT = 26,

  /**
   * @generated from enum value: METRIC_KIND_ONLINE_STORE_USED_MEMORY = 27;
   */
  ONLINE_STORE_USED_MEMORY = 27,

  /**
   * @generated from enum value: METRIC_KIND_ONLINE_STORE_TOTAL_MEMORY = 28;
   */
  ONLINE_STORE_TOTAL_MEMORY = 28,

  /**
   * @generated from enum value: METRIC_KIND_MEMORY_USAGE_BYTES = 29;
   */
  MEMORY_USAGE_BYTES = 29,

  /**
   * @generated from enum value: METRIC_KIND_TOTAL_MEMORY_AVAILABLE_BYTES = 30;
   */
  TOTAL_MEMORY_AVAILABLE_BYTES = 30,

  /**
   * @generated from enum value: METRIC_KIND_NETWORK_READ_BYTES = 31;
   */
  NETWORK_READ_BYTES = 31,

  /**
   * @generated from enum value: METRIC_KIND_NETWORK_WRITE_BYTES = 32;
   */
  NETWORK_WRITE_BYTES = 32,

  /**
   * @generated from enum value: METRIC_KIND_DISK_READ_BYTES = 33;
   */
  DISK_READ_BYTES = 33,

  /**
   * @generated from enum value: METRIC_KIND_DISK_WRITE_BYTES = 34;
   */
  DISK_WRITE_BYTES = 34,

  /**
   * @generated from enum value: METRIC_KIND_STREAM_LAG = 35;
   */
  STREAM_LAG = 35,

  /**
   * @generated from enum value: METRIC_KIND_USAGE = 36;
   */
  USAGE = 36,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_COMPUTED_COUNT = 37;
   */
  FEATURE_COMPUTED_COUNT = 37,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_LOOKED_UP_COUNT = 38;
   */
  FEATURE_LOOKED_UP_COUNT = 38,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_INTERMEDIATE_COUNT = 39;
   */
  FEATURE_INTERMEDIATE_COUNT = 39,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_COMPUTED_NULL_RATIO = 40;
   */
  FEATURE_COMPUTED_NULL_RATIO = 40,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_LOOKED_UP_NULL_RATIO = 41;
   */
  FEATURE_LOOKED_UP_NULL_RATIO = 41,

  /**
   * @generated from enum value: METRIC_KIND_FEATURE_INTERMEDIATE_NULL_RATIO = 42;
   */
  FEATURE_INTERMEDIATE_NULL_RATIO = 42,

  /**
   * @generated from enum value: METRIC_KIND_STREAM_INGEST_DELAY = 43;
   */
  STREAM_INGEST_DELAY = 43,

  /**
   * @generated from enum value: METRIC_KIND_CONTAINER_MEMORY_BYTES = 44;
   */
  CONTAINER_MEMORY_BYTES = 44,

  /**
   * @generated from enum value: METRIC_KIND_HOST_MEMORY_BYTES = 45;
   */
  HOST_MEMORY_BYTES = 45,

  /**
   * @generated from enum value: METRIC_KIND_CONTAINER_CPU_UTILIZATION = 46;
   */
  CONTAINER_CPU_UTILIZATION = 46,

  /**
   * @generated from enum value: METRIC_KIND_DISK_USED_BYTES = 47;
   */
  DISK_USED_BYTES = 47,

  /**
   * @generated from enum value: METRIC_KIND_DISK_AVAILABLE_BYTES = 48;
   */
  DISK_AVAILABLE_BYTES = 48,

  /**
   * @generated from enum value: METRIC_KIND_RESOLVER_INVOKER_NET_TX = 49;
   */
  RESOLVER_INVOKER_NET_TX = 49,

  /**
   * @generated from enum value: METRIC_KIND_RESOLVER_INVOKER_NET_RX = 50;
   */
  RESOLVER_INVOKER_NET_RX = 50,

  /**
   * @generated from enum value: METRIC_KIND_RESOLVER_INVOKER_ROWS_WRITTEN = 51;
   */
  RESOLVER_INVOKER_ROWS_WRITTEN = 51,

  /**
   * @generated from enum value: METRIC_KIND_TOPIC_MESSAGES_PROCESSED = 52;
   */
  TOPIC_MESSAGES_PROCESSED = 52,

  /**
   * @generated from enum value: METRIC_KIND_SUBSCRIPTION_NUM_UNACKED_MESSAGES = 53;
   */
  SUBSCRIPTION_NUM_UNACKED_MESSAGES = 53,

  /**
   * @generated from enum value: METRIC_KIND_SUBSCRIPTION_OLDEST_UNACKED_MESSAGE_AGE = 54;
   */
  SUBSCRIPTION_OLDEST_UNACKED_MESSAGE_AGE = 54,

  /**
   * @generated from enum value: METRIC_KIND_TOPIC_OFFSET_LAG = 55;
   */
  TOPIC_OFFSET_LAG = 55,

  /**
   * @generated from enum value: METRIC_KIND_GPU_UTILIZATION = 56;
   */
  GPU_UTILIZATION = 56,

  /**
   * @generated from enum value: METRIC_KIND_GPU_TENSOR_ACTIVITY = 57;
   */
  GPU_TENSOR_ACTIVITY = 57,

  /**
   * @generated from enum value: METRIC_KIND_GPU_SM_CLOCK_MHZ = 58;
   */
  GPU_SM_CLOCK_MHZ = 58,

  /**
   * @generated from enum value: METRIC_KIND_GPU_POWER_WATTS = 59;
   */
  GPU_POWER_WATTS = 59,

  /**
   * @generated from enum value: METRIC_KIND_GPU_TEMPERATURE_CELSIUS = 60;
   */
  GPU_TEMPERATURE_CELSIUS = 60,

  /**
   * @generated from enum value: METRIC_KIND_GPU_THROTTLE_REASONS = 61;
   */
  GPU_THROTTLE_REASONS = 61,

  /**
   * @generated from enum value: METRIC_KIND_GPU_FP16_ACTIVITY = 62;
   */
  GPU_FP16_ACTIVITY = 62,

  /**
   * @generated from enum value: METRIC_KIND_GPU_COUNT = 63;
   */
  GPU_COUNT = 63,

  /**
   * @generated from enum value: METRIC_KIND_PULL_QUERY_QUEUE_DEPTH = 64;
   */
  PULL_QUERY_QUEUE_DEPTH = 64,

  /**
   * @generated from enum value: METRIC_KIND_PULL_QUERY_OLDEST_UNACKED_AGE = 65;
   */
  PULL_QUERY_OLDEST_UNACKED_AGE = 65,

  /**
   * @generated from enum value: METRIC_KIND_PULL_QUERY_PROCESSED = 66;
   */
  PULL_QUERY_PROCESSED = 66,

  /**
   * @generated from enum value: METRIC_KIND_PULL_QUERY_LATENCY = 67;
   */
  PULL_QUERY_LATENCY = 67,

  /**
   * @generated from enum value: METRIC_KIND_CONTAINER_COUNT = 68;
   */
  CONTAINER_COUNT = 68,

  /**
   * @generated from enum value: METRIC_KIND_SCALING_GROUP_REPLICA_COUNT = 69;
   */
  SCALING_GROUP_REPLICA_COUNT = 69,

  /**
   * @generated from enum value: METRIC_KIND_PULL_QUERY_MAX_INFLIGHT = 70;
   */
  PULL_QUERY_MAX_INFLIGHT = 70,

  /**
   * @generated from enum value: METRIC_KIND_PULL_QUERY_CONCURRENCY_TARGET = 71;
   */
  PULL_QUERY_CONCURRENCY_TARGET = 71,

  /**
   * @generated from enum value: METRIC_KIND_PULL_QUERY_OPEN_CONNECTIONS = 72;
   */
  PULL_QUERY_OPEN_CONNECTIONS = 72,

  /**
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_ENQUEUED = 73;
   */
  FUNCTION_CALL_ENQUEUED = 73,

  /**
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_ENQUEUE_LATENCY = 74;
   */
  FUNCTION_CALL_ENQUEUE_LATENCY = 74,

  /**
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_OPEN_CONNECTIONS = 75;
   */
  FUNCTION_CALL_OPEN_CONNECTIONS = 75,

  /**
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_DEQUEUED = 76;
   */
  FUNCTION_CALL_DEQUEUED = 76,

  /**
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_PROCESSING_LATENCY = 77;
   */
  FUNCTION_CALL_PROCESSING_LATENCY = 77,

  /**
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_QUEUE_DEPTH = 78;
   */
  FUNCTION_CALL_QUEUE_DEPTH = 78,

  /**
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_INFLIGHT = 79;
   */
  FUNCTION_CALL_INFLIGHT = 79,

  /**
   * @generated from enum value: METRIC_KIND_POD_CONTAINER_MEMORY_BYTES = 80;
   */
  POD_CONTAINER_MEMORY_BYTES = 80,

  /**
   * @generated from enum value: METRIC_KIND_POD_CONTAINER_CPU_UTILIZATION = 81;
   */
  POD_CONTAINER_CPU_UTILIZATION = 81,

  /**
   * Query progress gauges emitted periodically by libchalk's report writer
   * for an in-flight query operation (query_progress namespace).
   *
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPLITS_PROCESSED = 82;
   */
  QUERY_PROGRESS_SPLITS_PROCESSED = 82,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPLITS_QUEUED = 83;
   */
  QUERY_PROGRESS_SPLITS_QUEUED = 83,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_BLOCKED_DRIVERS = 84;
   */
  QUERY_PROGRESS_BLOCKED_DRIVERS = 84,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_RESOLVER_ROWS_RETURNED = 85;
   */
  QUERY_PROGRESS_RESOLVER_ROWS_RETURNED = 85,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_OPERATOR_OUTPUT_BYTES = 86;
   */
  QUERY_PROGRESS_OPERATOR_OUTPUT_BYTES = 86,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_OPERATOR_ROWS_PROCESSED = 87;
   */
  QUERY_PROGRESS_OPERATOR_ROWS_PROCESSED = 87,

  /**
   * @generated from enum value: METRIC_KIND_SCHEDULED_QUERY_COUNT = 88;
   */
  SCHEDULED_QUERY_COUNT = 88,

  /**
   * @generated from enum value: METRIC_KIND_SCHEDULED_QUERY_SUCCESS_RATIO = 89;
   */
  SCHEDULED_QUERY_SUCCESS_RATIO = 89,

  /**
   * @generated from enum value: METRIC_KIND_HYPERVISOR_CONTAINER_CPU_UTILIZATION = 90;
   */
  HYPERVISOR_CONTAINER_CPU_UTILIZATION = 90,

  /**
   * @generated from enum value: METRIC_KIND_HYPERVISOR_CONTAINER_MEMORY_BYTES = 91;
   */
  HYPERVISOR_CONTAINER_MEMORY_BYTES = 91,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PLAN_LATENCY = 92;
   */
  QUERY_PLAN_LATENCY = 92,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPOOL_FLUSHED_BYTES = 93;
   */
  QUERY_PROGRESS_SPOOL_FLUSHED_BYTES = 93,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPOOL_RECLAIMED_BYTES = 94;
   */
  QUERY_PROGRESS_SPOOL_RECLAIMED_BYTES = 94,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPOOL_BUFFERED_BYTES = 95;
   */
  QUERY_PROGRESS_SPOOL_BUFFERED_BYTES = 95,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPOOL_OUTSTANDING_CHUNKS = 96;
   */
  QUERY_PROGRESS_SPOOL_OUTSTANDING_CHUNKS = 96,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPILLED_BYTES = 97;
   */
  QUERY_PROGRESS_SPILLED_BYTES = 97,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPILLED_ROWS = 98;
   */
  QUERY_PROGRESS_SPILLED_ROWS = 98,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPILL_OUTSTANDING_BYTES = 99;
   */
  QUERY_PROGRESS_SPILL_OUTSTANDING_BYTES = 99,

  /**
   * @generated from enum value: METRIC_KIND_QUERY_PROGRESS_SPILL_TIME_MS = 100;
   */
  QUERY_PROGRESS_SPILL_TIME_MS = 100,

  /**
   * VM-only cumulative counters emitted by Vector's collector and aggregator
   * self-observability pipeline.
   *
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_LOG_RECEIVED = 101;
   */
  TELEMETRY_PIPELINE_LOG_RECEIVED = 101,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_LOG_EMITTED = 102;
   */
  TELEMETRY_PIPELINE_LOG_EMITTED = 102,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_LOG_DROPPED = 103;
   */
  TELEMETRY_PIPELINE_LOG_DROPPED = 103,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_METRIC_RECEIVED = 104;
   */
  TELEMETRY_PIPELINE_METRIC_RECEIVED = 104,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_METRIC_EMITTED = 105;
   */
  TELEMETRY_PIPELINE_METRIC_EMITTED = 105,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_METRIC_DROPPED = 106;
   */
  TELEMETRY_PIPELINE_METRIC_DROPPED = 106,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_TRACE_RECEIVED = 107;
   */
  TELEMETRY_PIPELINE_TRACE_RECEIVED = 107,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_TRACE_EMITTED = 108;
   */
  TELEMETRY_PIPELINE_TRACE_EMITTED = 108,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_TRACE_DROPPED = 109;
   */
  TELEMETRY_PIPELINE_TRACE_DROPPED = 109,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_MIXED_RECEIVED = 110;
   */
  TELEMETRY_PIPELINE_MIXED_RECEIVED = 110,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_MIXED_EMITTED = 111;
   */
  TELEMETRY_PIPELINE_MIXED_EMITTED = 111,

  /**
   * @generated from enum value: METRIC_KIND_TELEMETRY_PIPELINE_MIXED_DROPPED = 112;
   */
  TELEMETRY_PIPELINE_MIXED_DROPPED = 112,

  /**
   * DCGM framebuffer gauges, stored in bytes. The exporter's default counter set
   * has no total, so device capacity is used + free (+ a small reserved region).
   *
   * @generated from enum value: METRIC_KIND_GPU_MEMORY_USED_BYTES = 113;
   */
  GPU_MEMORY_USED_BYTES = 113,

  /**
   * @generated from enum value: METRIC_KIND_GPU_MEMORY_FREE_BYTES = 114;
   */
  GPU_MEMORY_FREE_BYTES = 114,

  /**
   * Counts pods whose maximum container CPU utilization in a chart bucket is at
   * or below the fixed low-utilization threshold.
   *
   * @generated from enum value: METRIC_KIND_LOW_CPU_UTILIZATION_POD_COUNT = 115;
   */
  LOW_CPU_UTILIZATION_POD_COUNT = 115,

  /**
   * Percent (0-100) of the fullest mounted filesystem in use, computed per mount
   * before being reduced so both gauges come from the same disk.
   *
   * @generated from enum value: METRIC_KIND_DISK_USED_PERCENT = 116;
   */
  DISK_USED_PERCENT = 116,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_CPU_PCT_USED = 117;
   */
  CLICKHOUSE_CPU_PCT_USED = 117,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_CPU_SYSTEM_TIME = 118;
   */
  CLICKHOUSE_CPU_SYSTEM_TIME = 118,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_CPU_IDLE_TIME = 119;
   */
  CLICKHOUSE_CPU_IDLE_TIME = 119,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_CPU_USER_TIME = 120;
   */
  CLICKHOUSE_CPU_USER_TIME = 120,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_MEMORY_LIMIT_BYTES = 121;
   */
  CLICKHOUSE_MEMORY_LIMIT_BYTES = 121,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_MEMORY_PCT_USED = 122;
   */
  CLICKHOUSE_MEMORY_PCT_USED = 122,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_MEMORY_USED_BYTES = 123;
   */
  CLICKHOUSE_MEMORY_USED_BYTES = 123,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_QUERY_COUNT = 124;
   */
  CLICKHOUSE_QUERY_COUNT = 124,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_QUERY_LATENCY_AVG_MS = 125;
   */
  CLICKHOUSE_QUERY_LATENCY_AVG_MS = 125,

  /**
   * @generated from enum value: METRIC_KIND_CLICKHOUSE_QUERY_LATENCY_MAX_MS = 126;
   */
  CLICKHOUSE_QUERY_LATENCY_MAX_MS = 126,

  /**
   * Online store bytes held by keys and values, excluding allocator and buffer
   * overhead. Unlike ONLINE_STORE_USED_MEMORY, which is RSS, this falls when keys
   * are deleted.
   *
   * @generated from enum value: METRIC_KIND_ONLINE_STORE_DATASET_SIZE = 127;
   */
  ONLINE_STORE_DATASET_SIZE = 127,

  /**
   * Bytes the online store's allocator holds, which is what its eviction limit
   * applies to. ONLINE_STORE_USED_MEMORY is RSS and sits above this; DATASET_SIZE
   * excludes keyspace overhead and sits below it.
   *
   * @generated from enum value: METRIC_KIND_ONLINE_STORE_ALLOCATED_MEMORY = 128;
   */
  ONLINE_STORE_ALLOCATED_MEMORY = 128,

  /**
   * Whole bound offline-store dataset/schema size in bytes; the denominator for
   * the accelerated (wide-table) share. Emitted at wide-table fill/compaction ends.
   *
   * @generated from enum value: METRIC_KIND_OFFLINE_STORE_TOTAL_BYTES = 129;
   */
  OFFLINE_STORE_TOTAL_BYTES = 129,

  /**
   * A namespace's active wide feature-view table size in bytes; the accelerated
   * numerator, keyed by GROUP_BY_KIND_NAMESPACE. Emitted alongside TOTAL_BYTES.
   *
   * @generated from enum value: METRIC_KIND_OFFLINE_STORE_WIDE_BYTES = 130;
   */
  OFFLINE_STORE_WIDE_BYTES = 130,

  /**
   * Time from when Chalk received a streaming message to processing
   * completion; STREAM_INGEST_DELAY minus this is time spent in the bus.
   *
   * @generated from enum value: METRIC_KIND_STREAM_MESSAGE_PROCESSING_DURATION = 131;
   */
  STREAM_MESSAGE_PROCESSING_DURATION = 131,

  /**
   * Storage "Accelerated" tile: completed offline queries (denominator) and the subset
   * whose plan read a wide table / MFV (numerator). VM-only, no Timescale series.
   *
   * @generated from enum value: METRIC_KIND_OFFLINE_QUERY_COMPLETED = 132;
   */
  OFFLINE_QUERY_COMPLETED = 132,

  /**
   * @generated from enum value: METRIC_KIND_OFFLINE_QUERY_ACCELERATED = 133;
   */
  OFFLINE_QUERY_ACCELERATED = 133,

  /**
   * Model training metrics emitted via chalk_train.log_metrics.
   *
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_ACCURACY = 134;
   */
  MODEL_TRAINING_ACCURACY = 134,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_LOSS = 135;
   */
  MODEL_TRAINING_LOSS = 135,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_PRECISION = 136;
   */
  MODEL_TRAINING_PRECISION = 136,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_RECALL = 137;
   */
  MODEL_TRAINING_RECALL = 137,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_F1 = 138;
   */
  MODEL_TRAINING_F1 = 138,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_MAE = 139;
   */
  MODEL_TRAINING_MAE = 139,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_MSE = 140;
   */
  MODEL_TRAINING_MSE = 140,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_RMSE = 141;
   */
  MODEL_TRAINING_RMSE = 141,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_R2 = 142;
   */
  MODEL_TRAINING_R2 = 142,

  /**
   * Total requests Envoy sent to upstream clusters. This is backed directly by
   * Envoy's cumulative Prometheus counter rather than Chalk's metric pipeline.
   *
   * @generated from enum value: METRIC_KIND_ENVOY_UPSTREAM_REQUEST_COUNT = 143;
   */
  ENVOY_UPSTREAM_REQUEST_COUNT = 143,

  /**
   * @generated from enum value: METRIC_KIND_POD_STATE_COUNT = 144;
   */
  POD_STATE_COUNT = 144,

  /**
   * @generated from enum value: METRIC_KIND_CONTAINER_CRASHES = 145;
   */
  CONTAINER_CRASHES = 145,

  /**
   * Reinforcement learning metrics emitted via chalk_train.log_metrics.
   *
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_REWARD = 146;
   */
  MODEL_TRAINING_REWARD = 146,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_REWARD_STD = 147;
   */
  MODEL_TRAINING_REWARD_STD = 147,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_PASS_RATE = 148;
   */
  MODEL_TRAINING_PASS_RATE = 148,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_KL = 149;
   */
  MODEL_TRAINING_KL = 149,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_ENTROPY = 150;
   */
  MODEL_TRAINING_ENTROPY = 150,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_GRAD_NORM = 151;
   */
  MODEL_TRAINING_GRAD_NORM = 151,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_LEARNING_RATE = 152;
   */
  MODEL_TRAINING_LEARNING_RATE = 152,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_RESPONSE_LENGTH = 153;
   */
  MODEL_TRAINING_RESPONSE_LENGTH = 153,

  /**
   * Divergence between the policy that sampled the rollouts and the policy being trained,
   * measured on the sampled tokens. Not a KL penalty: it reports how far off-policy an
   * asynchronous RL step is.
   *
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_MISMATCH_KL = 169;
   */
  MODEL_TRAINING_MISMATCH_KL = 169,

  /**
   * Sandbox lifecycle metrics combine the available Kubernetes and hypervisor telemetry.
   *
   * @generated from enum value: METRIC_KIND_SANDBOX_STATE_COUNT = 154;
   */
  SANDBOX_STATE_COUNT = 154,

  /**
   * @generated from enum value: METRIC_KIND_SANDBOX_STARTUP_LATENCY = 155;
   */
  SANDBOX_STARTUP_LATENCY = 155,

  /**
   * Sandbox resource metrics. The chart backend reads each runtime's
   * native telemetry and combines the results without requiring common emitters.
   *
   * @generated from enum value: METRIC_KIND_SANDBOX_MEMORY_USED_BYTES = 156;
   */
  SANDBOX_MEMORY_USED_BYTES = 156,

  /**
   * @generated from enum value: METRIC_KIND_SANDBOX_CPU_USAGE_CORES = 157;
   */
  SANDBOX_CPU_USAGE_CORES = 157,

  /**
   * @generated from enum value: METRIC_KIND_SANDBOX_CPU_REQUEST_CORES = 158;
   */
  SANDBOX_CPU_REQUEST_CORES = 158,

  /**
   * @generated from enum value: METRIC_KIND_SANDBOX_MEMORY_REQUEST_BYTES = 159;
   */
  SANDBOX_MEMORY_REQUEST_BYTES = 159,

  /**
   * Per-sandbox usage divided by its configured request, before cross-sandbox aggregation.
   *
   * @generated from enum value: METRIC_KIND_SANDBOX_CPU_UTILIZATION = 160;
   */
  SANDBOX_CPU_UTILIZATION = 160,

  /**
   * @generated from enum value: METRIC_KIND_SANDBOX_MEMORY_UTILIZATION = 161;
   */
  SANDBOX_MEMORY_UTILIZATION = 161,

  /**
   * Reward broken out by the reward function that scored it (labelled `rubric`) and by the task
   * (the environment a rollout came from, labelled `task`). Separate from
   * METRIC_KIND_MODEL_TRAINING_REWARD so an ungrouped reward chart stays the overall reward.
   *
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_RUBRIC_REWARD = 162;
   */
  MODEL_TRAINING_RUBRIC_REWARD = 162,

  /**
   * @generated from enum value: METRIC_KIND_MODEL_TRAINING_TASK_REWARD = 163;
   */
  MODEL_TRAINING_TASK_REWARD = 163,

  /**
   * VictoriaMetrics storage gauges emitted by the cluster manager. These series
   * carry both environment_id and kube_cluster_name so endpoints can apply their
   * own trusted scope while sharing the same metric vocabulary.
   *
   * @generated from enum value: METRIC_KIND_VICTORIA_METRICS_DISK_USED_BYTES = 164;
   */
  VICTORIA_METRICS_DISK_USED_BYTES = 164,

  /**
   * @generated from enum value: METRIC_KIND_VICTORIA_METRICS_DISK_FREE_BYTES = 165;
   */
  VICTORIA_METRICS_DISK_FREE_BYTES = 165,

  /**
   * @generated from enum value: METRIC_KIND_VICTORIA_METRICS_DISK_TOTAL_BYTES = 166;
   */
  VICTORIA_METRICS_DISK_TOTAL_BYTES = 166,

  /**
   * Existing query-request counts divided by the aggregation window's duration in seconds.
   *
   * @generated from enum value: METRIC_KIND_QUERY_RATE = 167;
   */
  QUERY_RATE = 167,

  /**
   * Processed stream messages per second, averaged over each aggregation window.
   *
   * @generated from enum value: METRIC_KIND_STREAM_MESSAGE_RATE = 168;
   */
  STREAM_MESSAGE_RATE = 168,

  /**
   * Redis admission to first worker delivery, in milliseconds.
   *
   * @generated from enum value: METRIC_KIND_FUNCTION_CALL_QUEUE_DURATION = 170;
   */
  FUNCTION_CALL_QUEUE_DURATION = 170,
}

/**
 * Describes the enum chalk.artifacts.v1.MetricKind.
 */
export const MetricKindSchema: GenEnum<MetricKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 0);

/**
 * @generated from enum chalk.artifacts.v1.FilterKind
 */
export enum FilterKind {
  /**
   * @generated from enum value: FILTER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILTER_KIND_FEATURE_STATUS = 1;
   */
  FEATURE_STATUS = 1,

  /**
   * @generated from enum value: FILTER_KIND_FEATURE_NAME = 2;
   */
  FEATURE_NAME = 2,

  /**
   * @generated from enum value: FILTER_KIND_FEATURE_TAG = 3;
   */
  FEATURE_TAG = 3,

  /**
   * @generated from enum value: FILTER_KIND_RESOLVER_STATUS = 4;
   */
  RESOLVER_STATUS = 4,

  /**
   * @generated from enum value: FILTER_KIND_RESOLVER_NAME = 5;
   */
  RESOLVER_NAME = 5,

  /**
   * @generated from enum value: FILTER_KIND_RESOLVER_TAG = 6;
   */
  RESOLVER_TAG = 6,

  /**
   * @generated from enum value: FILTER_KIND_CRON_STATUS = 7;
   */
  CRON_STATUS = 7,

  /**
   * @generated from enum value: FILTER_KIND_MIGRATION_STATUS = 8;
   */
  MIGRATION_STATUS = 8,

  /**
   * @generated from enum value: FILTER_KIND_ONLINE_OFFLINE = 9;
   */
  ONLINE_OFFLINE = 9,

  /**
   * @generated from enum value: FILTER_KIND_CACHE_HIT = 10;
   */
  CACHE_HIT = 10,

  /**
   * @generated from enum value: FILTER_KIND_OPERATION_ID = 11;
   */
  OPERATION_ID = 11,

  /**
   * @generated from enum value: FILTER_KIND_QUERY_NAME = 12;
   */
  QUERY_NAME = 12,

  /**
   * @generated from enum value: FILTER_KIND_QUERY_STATUS = 13;
   */
  QUERY_STATUS = 13,

  /**
   * @generated from enum value: FILTER_KIND_IS_NULL = 14;
   */
  IS_NULL = 14,

  /**
   * @generated from enum value: FILTER_KIND_USAGE_KIND = 15;
   */
  USAGE_KIND = 15,

  /**
   * @generated from enum value: FILTER_KIND_RESOURCE_GROUP = 16;
   */
  RESOURCE_GROUP = 16,

  /**
   * @generated from enum value: FILTER_KIND_POD_NAME = 17;
   */
  POD_NAME = 17,

  /**
   * @generated from enum value: FILTER_KIND_COMPUTATION_CONTEXT = 18;
   */
  COMPUTATION_CONTEXT = 18,

  /**
   * @generated from enum value: FILTER_KIND_TOPIC_NAME = 19;
   */
  TOPIC_NAME = 19,

  /**
   * @generated from enum value: FILTER_KIND_SUBSCRIPTION_NAME = 20;
   */
  SUBSCRIPTION_NAME = 20,

  /**
   * @generated from enum value: FILTER_KIND_PARTITION_NAME = 21;
   */
  PARTITION_NAME = 21,

  /**
   * @generated from enum value: FILTER_KIND_SCALING_GROUP = 22;
   */
  SCALING_GROUP = 22,

  /**
   * @generated from enum value: FILTER_KIND_FUNCTION_NAME = 23;
   */
  FUNCTION_NAME = 23,

  /**
   * @generated from enum value: FILTER_KIND_SERVICE_KIND = 24;
   */
  SERVICE_KIND = 24,

  /**
   * @generated from enum value: FILTER_KIND_CONSUMER_GROUP = 25;
   */
  CONSUMER_GROUP = 25,

  /**
   * @generated from enum value: FILTER_KIND_CONTAINER_ID = 26;
   */
  CONTAINER_ID = 26,

  /**
   * @generated from enum value: FILTER_KIND_PLANNER = 27;
   */
  PLANNER = 27,

  /**
   * @generated from enum value: FILTER_KIND_PLAN_REASON = 28;
   */
  PLAN_REASON = 28,

  /**
   * @generated from enum value: FILTER_KIND_FUNCTION_CALL_MODE = 29;
   */
  FUNCTION_CALL_MODE = 29,

  /**
   * The operation ID of an offline query specifically. Distinct from
   * FILTER_KIND_OPERATION_ID, which spans every computation context: only the
   * offline-query subset survives into VictoriaMetrics, so a chart slicing per
   * operation must say which it means. See go-api-server/charts/vm_registry.go.
   *
   * @generated from enum value: FILTER_KIND_OFFLINE_QUERY_OPERATION_ID = 30;
   */
  OFFLINE_QUERY_OPERATION_ID = 30,

  /**
   * The remaining computation contexts whose operation IDs VictoriaMetrics
   * retains, each under its own label. A chart must name the context it means;
   * FILTER_KIND_OPERATION_ID stays unresolvable there.
   *
   * @generated from enum value: FILTER_KIND_SCRIPT_TASK_OPERATION_ID = 31;
   */
  SCRIPT_TASK_OPERATION_ID = 31,

  /**
   * @generated from enum value: FILTER_KIND_CRON_OPERATION_ID = 32;
   */
  CRON_OPERATION_ID = 32,

  /**
   * @generated from enum value: FILTER_KIND_CHALKSQL_OPERATION_ID = 33;
   */
  CHALKSQL_OPERATION_ID = 33,

  /**
   * The Kubernetes node a metric was observed on. Distinct from
   * FILTER_KIND_POD_NAME: both address the `source` column, but the node
   * namespace stores a bare node name there, with no "namespace/podName"
   * shape to unpack. The GPU gauges are the node-scoped metrics today —
   * DCGM reports per device per node, not per pod.
   *
   * @generated from enum value: FILTER_KIND_NODE_NAME = 34;
   */
  NODE_NAME = 34,

  /**
   * The scaling-group revision that executed a function call. Function-call
   * metrics persist this value in the shared operation_id storage dimension,
   * but it is not a query operation ID and must not use operation formatting.
   *
   * @generated from enum value: FILTER_KIND_SCALING_GROUP_REVISION_ID = 35;
   */
  SCALING_GROUP_REVISION_ID = 35,

  /**
   * The feature-view namespace of an offline-store wide-table size metric.
   *
   * @generated from enum value: FILTER_KIND_NAMESPACE = 36;
   */
  NAMESPACE = 36,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_RUN_ID = 37;
   */
  TRAINING_RUN_ID = 37,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_STEP = 38;
   */
  TRAINING_STEP = 38,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_SPLIT = 39;
   */
  TRAINING_SPLIT = 39,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_CLASS = 40;
   */
  TRAINING_CLASS = 40,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_THRESHOLD = 41;
   */
  TRAINING_THRESHOLD = 41,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_OPTIMIZER = 42;
   */
  TRAINING_OPTIMIZER = 42,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_MODEL_VERSION = 43;
   */
  TRAINING_MODEL_VERSION = 43,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_EPOCH = 44;
   */
  TRAINING_EPOCH = 44,

  /**
   * @generated from enum value: FILTER_KIND_POD_STATE = 45;
   */
  POD_STATE = 45,

  /**
   * @generated from enum value: FILTER_KIND_CONTAINER_CRASH_REASON = 46;
   */
  CONTAINER_CRASH_REASON = 46,

  /**
   * @generated from enum value: FILTER_KIND_WORKLOAD_RUNTIME = 48;
   */
  WORKLOAD_RUNTIME = 48,

  /**
   * @generated from enum value: FILTER_KIND_WORKLOAD_STATE = 49;
   */
  WORKLOAD_STATE = 49,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_RUBRIC = 50;
   */
  TRAINING_RUBRIC = 50,

  /**
   * @generated from enum value: FILTER_KIND_TRAINING_TASK = 51;
   */
  TRAINING_TASK = 51,

  /**
   * Canonical GPU workload identity: sandbox container ID or scaling-group ID.
   *
   * @generated from enum value: FILTER_KIND_WORKLOAD_ID = 52;
   */
  WORKLOAD_ID = 52,
}

/**
 * Describes the enum chalk.artifacts.v1.FilterKind.
 */
export const FilterKindSchema: GenEnum<FilterKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 1);

/**
 * @generated from enum chalk.artifacts.v1.ComparatorKind
 */
export enum ComparatorKind {
  /**
   * @generated from enum value: COMPARATOR_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMPARATOR_KIND_EQ = 1;
   */
  EQ = 1,

  /**
   * @generated from enum value: COMPARATOR_KIND_NEQ = 2;
   */
  NEQ = 2,

  /**
   * @generated from enum value: COMPARATOR_KIND_ONE_OF = 3;
   */
  ONE_OF = 3,
}

/**
 * Describes the enum chalk.artifacts.v1.ComparatorKind.
 */
export const ComparatorKindSchema: GenEnum<ComparatorKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 2);

/**
 * @generated from enum chalk.artifacts.v1.WindowFunctionKind
 */
export enum WindowFunctionKind {
  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_COUNT = 1;
   */
  COUNT = 1,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_MEAN = 2;
   */
  MEAN = 2,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_SUM = 3;
   */
  SUM = 3,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_MIN = 4;
   */
  MIN = 4,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_MAX = 5;
   */
  MAX = 5,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_PERCENTILE_99 = 6;
   */
  PERCENTILE_99 = 6,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_PERCENTILE_95 = 7;
   */
  PERCENTILE_95 = 7,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_PERCENTILE_75 = 8;
   */
  PERCENTILE_75 = 8,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_PERCENTILE_50 = 9;
   */
  PERCENTILE_50 = 9,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_PERCENTILE_25 = 10;
   */
  PERCENTILE_25 = 10,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_PERCENTILE_5 = 11;
   */
  PERCENTILE_5 = 11,

  /**
   * @generated from enum value: WINDOW_FUNCTION_KIND_ALL_PERCENTILES = 12;
   */
  ALL_PERCENTILES = 12,
}

/**
 * Describes the enum chalk.artifacts.v1.WindowFunctionKind.
 */
export const WindowFunctionKindSchema: GenEnum<WindowFunctionKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 3);

/**
 * @generated from enum chalk.artifacts.v1.GroupByKind
 */
export enum GroupByKind {
  /**
   * @generated from enum value: GROUP_BY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GROUP_BY_KIND_FEATURE_STATUS = 1;
   */
  FEATURE_STATUS = 1,

  /**
   * @generated from enum value: GROUP_BY_KIND_FEATURE_NAME = 2;
   */
  FEATURE_NAME = 2,

  /**
   * @generated from enum value: GROUP_BY_KIND_IS_NULL = 3;
   */
  IS_NULL = 3,

  /**
   * @generated from enum value: GROUP_BY_KIND_RESOLVER_STATUS = 4;
   */
  RESOLVER_STATUS = 4,

  /**
   * @generated from enum value: GROUP_BY_KIND_RESOLVER_NAME = 5;
   */
  RESOLVER_NAME = 5,

  /**
   * @generated from enum value: GROUP_BY_KIND_QUERY_STATUS = 6;
   */
  QUERY_STATUS = 6,

  /**
   * @generated from enum value: GROUP_BY_KIND_QUERY_NAME = 7;
   */
  QUERY_NAME = 7,

  /**
   * @generated from enum value: GROUP_BY_KIND_ONLINE_OFFLINE = 8;
   */
  ONLINE_OFFLINE = 8,

  /**
   * @generated from enum value: GROUP_BY_KIND_CACHE_HIT = 9;
   */
  CACHE_HIT = 9,

  /**
   * @generated from enum value: GROUP_BY_KIND_USAGE_KIND = 10;
   */
  USAGE_KIND = 10,

  /**
   * @generated from enum value: GROUP_BY_KIND_RESOURCE_GROUP = 11;
   */
  RESOURCE_GROUP = 11,

  /**
   * @generated from enum value: GROUP_BY_KIND_DEPLOYMENT_ID = 12;
   */
  DEPLOYMENT_ID = 12,

  /**
   * @generated from enum value: GROUP_BY_KIND_OPERATION_ID = 13;
   */
  OPERATION_ID = 13,

  /**
   * @generated from enum value: GROUP_BY_KIND_POD_NAME = 14;
   */
  POD_NAME = 14,

  /**
   * @generated from enum value: GROUP_BY_KIND_TOPIC_NAME = 15;
   */
  TOPIC_NAME = 15,

  /**
   * @generated from enum value: GROUP_BY_KIND_SUBSCRIPTION_NAME = 16;
   */
  SUBSCRIPTION_NAME = 16,

  /**
   * @generated from enum value: GROUP_BY_KIND_PARTITION_NAME = 17;
   */
  PARTITION_NAME = 17,

  /**
   * @generated from enum value: GROUP_BY_KIND_FUNCTION_NAME = 18;
   */
  FUNCTION_NAME = 18,

  /**
   * @generated from enum value: GROUP_BY_KIND_SERVICE_KIND = 19;
   */
  SERVICE_KIND = 19,

  /**
   * @generated from enum value: GROUP_BY_KIND_CONSUMER_GROUP = 20;
   */
  CONSUMER_GROUP = 20,

  /**
   * @generated from enum value: GROUP_BY_KIND_PLANNER = 21;
   */
  PLANNER = 21,

  /**
   * @generated from enum value: GROUP_BY_KIND_PLAN_REASON = 22;
   */
  PLAN_REASON = 22,

  /**
   * @generated from enum value: GROUP_BY_KIND_TELEMETRY_PIPELINE_ROLE = 23;
   */
  TELEMETRY_PIPELINE_ROLE = 23,

  /**
   * @generated from enum value: GROUP_BY_KIND_TELEMETRY_PIPELINE_STEP = 24;
   */
  TELEMETRY_PIPELINE_STEP = 24,

  /**
   * @generated from enum value: GROUP_BY_KIND_TELEMETRY_PIPELINE_DROP_SCOPE = 25;
   */
  TELEMETRY_PIPELINE_DROP_SCOPE = 25,

  /**
   * Per-operation breakdown restricted to offline queries; see
   * FILTER_KIND_OFFLINE_QUERY_OPERATION_ID.
   *
   * @generated from enum value: GROUP_BY_KIND_OFFLINE_QUERY_OPERATION_ID = 26;
   */
  OFFLINE_QUERY_OPERATION_ID = 26,

  /**
   * Per-operation breakdowns for the other retained contexts; see
   * FILTER_KIND_SCRIPT_TASK_OPERATION_ID.
   *
   * @generated from enum value: GROUP_BY_KIND_SCRIPT_TASK_OPERATION_ID = 27;
   */
  SCRIPT_TASK_OPERATION_ID = 27,

  /**
   * @generated from enum value: GROUP_BY_KIND_CRON_OPERATION_ID = 28;
   */
  CRON_OPERATION_ID = 28,

  /**
   * @generated from enum value: GROUP_BY_KIND_CHALKSQL_OPERATION_ID = 29;
   */
  CHALKSQL_OPERATION_ID = 29,

  /**
   * The scaling-group revision that executed a function call; see
   * FILTER_KIND_SCALING_GROUP_REVISION_ID.
   *
   * @generated from enum value: GROUP_BY_KIND_SCALING_GROUP_REVISION_ID = 30;
   */
  SCALING_GROUP_REVISION_ID = 30,

  /**
   * The feature-view namespace an offline-store wide-table size is keyed by; see
   * FILTER_KIND_NAMESPACE.
   *
   * @generated from enum value: GROUP_BY_KIND_NAMESPACE = 31;
   */
  NAMESPACE = 31,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_RUN_ID = 32;
   */
  TRAINING_RUN_ID = 32,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_STEP = 33;
   */
  TRAINING_STEP = 33,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_SPLIT = 34;
   */
  TRAINING_SPLIT = 34,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_CLASS = 35;
   */
  TRAINING_CLASS = 35,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_THRESHOLD = 36;
   */
  TRAINING_THRESHOLD = 36,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_OPTIMIZER = 37;
   */
  TRAINING_OPTIMIZER = 37,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_MODEL_VERSION = 38;
   */
  TRAINING_MODEL_VERSION = 38,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_EPOCH = 39;
   */
  TRAINING_EPOCH = 39,

  /**
   * @generated from enum value: GROUP_BY_KIND_ENVOY_CLUSTER = 40;
   */
  ENVOY_CLUSTER = 40,

  /**
   * @generated from enum value: GROUP_BY_KIND_POD_STATE = 41;
   */
  POD_STATE = 41,

  /**
   * @generated from enum value: GROUP_BY_KIND_CONTAINER_CRASH_REASON = 42;
   */
  CONTAINER_CRASH_REASON = 42,

  /**
   * @generated from enum value: GROUP_BY_KIND_WORKLOAD_RUNTIME = 44;
   */
  WORKLOAD_RUNTIME = 44,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_RUBRIC = 46;
   */
  TRAINING_RUBRIC = 46,

  /**
   * @generated from enum value: GROUP_BY_KIND_TRAINING_TASK = 47;
   */
  TRAINING_TASK = 47,
}

/**
 * Describes the enum chalk.artifacts.v1.GroupByKind.
 */
export const GroupByKindSchema: GenEnum<GroupByKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 4);

/**
 * @generated from enum chalk.artifacts.v1.MetricFormulaKind
 */
export enum MetricFormulaKind {
  /**
   * @generated from enum value: METRIC_FORMULA_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_SUM = 1;
   */
  SUM = 1,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_TOTAL_RATIO = 2;
   */
  TOTAL_RATIO = 2,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_RATIO = 3;
   */
  RATIO = 3,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_PRODUCT = 4;
   */
  PRODUCT = 4,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_ABS = 5;
   */
  ABS = 5,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_KS_STAT = 6;
   */
  KS_STAT = 6,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_KS_TEST = 7;
   */
  KS_TEST = 7,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_KS_THRESHOLD = 8;
   */
  KS_THRESHOLD = 8,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_TIME_OFFSET = 9;
   */
  TIME_OFFSET = 9,

  /**
   * @generated from enum value: METRIC_FORMULA_KIND_SUB = 10;
   */
  SUB = 10,
}

/**
 * Describes the enum chalk.artifacts.v1.MetricFormulaKind.
 */
export const MetricFormulaKindSchema: GenEnum<MetricFormulaKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 5);

/**
 * @generated from enum chalk.artifacts.v1.AlertSeverityKind
 */
export enum AlertSeverityKind {
  /**
   * @generated from enum value: ALERT_SEVERITY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ALERT_SEVERITY_KIND_CRITICAL = 1;
   */
  CRITICAL = 1,

  /**
   * @generated from enum value: ALERT_SEVERITY_KIND_ERROR = 2;
   */
  ERROR = 2,

  /**
   * @generated from enum value: ALERT_SEVERITY_KIND_WARNING = 3;
   */
  WARNING = 3,

  /**
   * @generated from enum value: ALERT_SEVERITY_KIND_INFO = 4;
   */
  INFO = 4,

  /**
   * @generated from enum value: ALERT_SEVERITY_KIND_RESOLVED = 5;
   */
  RESOLVED = 5,
}

/**
 * Describes the enum chalk.artifacts.v1.AlertSeverityKind.
 */
export const AlertSeverityKindSchema: GenEnum<AlertSeverityKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 6);

/**
 * @generated from enum chalk.artifacts.v1.ThresholdKind
 */
export enum ThresholdKind {
  /**
   * @generated from enum value: THRESHOLD_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: THRESHOLD_KIND_ABOVE = 1;
   */
  ABOVE = 1,

  /**
   * @generated from enum value: THRESHOLD_KIND_BELOW = 2;
   */
  BELOW = 2,

  /**
   * @generated from enum value: THRESHOLD_KIND_GREATER_EQUAL = 3;
   */
  GREATER_EQUAL = 3,

  /**
   * @generated from enum value: THRESHOLD_KIND_LESS_EQUAL = 4;
   */
  LESS_EQUAL = 4,

  /**
   * @generated from enum value: THRESHOLD_KIND_EQUAL = 5;
   */
  EQUAL = 5,

  /**
   * @generated from enum value: THRESHOLD_KIND_NOT_EQUAL = 6;
   */
  NOT_EQUAL = 6,
}

/**
 * Describes the enum chalk.artifacts.v1.ThresholdKind.
 */
export const ThresholdKindSchema: GenEnum<ThresholdKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 7);

/**
 * @generated from enum chalk.artifacts.v1.ChartLinkKind
 */
export enum ChartLinkKind {
  /**
   * @generated from enum value: CHART_LINK_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHART_LINK_KIND_RESOLVER = 1;
   */
  RESOLVER = 1,

  /**
   * @generated from enum value: CHART_LINK_KIND_FEATURE = 2;
   */
  FEATURE = 2,

  /**
   * @generated from enum value: CHART_LINK_KIND_QUERY = 3;
   */
  QUERY = 3,

  /**
   * @generated from enum value: CHART_LINK_KIND_MANUAL = 4;
   */
  MANUAL = 4,

  /**
   * @generated from enum value: CHART_LINK_KIND_SCHEDULED_QUERY = 5;
   */
  SCHEDULED_QUERY = 5,
}

/**
 * Describes the enum chalk.artifacts.v1.ChartLinkKind.
 */
export const ChartLinkKindSchema: GenEnum<ChartLinkKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 8);

/**
 * RawMetricValueKind is how a raw series' samples combine over a chart bucket.
 *
 * @generated from enum chalk.artifacts.v1.RawMetricValueKind
 */
export enum RawMetricValueKind {
  /**
   * @generated from enum value: RAW_METRIC_VALUE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Instantaneous value; aggregated with avg/min/max/sum_over_time.
   *
   * @generated from enum value: RAW_METRIC_VALUE_KIND_GAUGE = 1;
   */
  GAUGE = 1,

  /**
   * Monotonic Prometheus counter; per-bucket values come from increase().
   *
   * @generated from enum value: RAW_METRIC_VALUE_KIND_COUNTER = 2;
   */
  COUNTER = 2,

  /**
   * Prometheus/vmrange bucket series; percentiles come from histogram_quantile().
   *
   * @generated from enum value: RAW_METRIC_VALUE_KIND_HISTOGRAM = 3;
   */
  HISTOGRAM = 3,

  /**
   * Non-cumulative per-flush increment; summed with sum_over_time(). Never use
   * increase() on these — the dips between windows would read as counter resets.
   *
   * @generated from enum value: RAW_METRIC_VALUE_KIND_DELTA_COUNT = 4;
   */
  DELTA_COUNT = 4,
}

/**
 * Describes the enum chalk.artifacts.v1.RawMetricValueKind.
 */
export const RawMetricValueKindSchema: GenEnum<RawMetricValueKind> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_chart, 9);

